// English translations — the master locale and the only one maintained by
// hand. Every other locale is generated from this file into
// locales/<code>.json by scripts/translate-client.py (`./wb i18n`); a key
// missing there falls through to this one (the configured `fallbackLocale`).
// New and changed strings land here only.
//
// Hierarchy mirrors the editor / component the string belongs to.
// Shared atoms live under `common.*`; per-editor blocks under
// the editor name. Add a sub-block when a section grows past ~5
// keys.

export default {
  preview: {
    title: 'UI preview',
    intro: "Every building block of the component library in its states — the reference for corporate-design.md. Switch the theme to check dark mode.",
    themeLight: 'Light',
    themeDark: 'Dark',
    buttons: 'Buttons — four roles',
    sizes: 'Sizes and states',
    iconButtons: 'Icon buttons — tooltip and label required',
    toolbar: 'Toolbar',
    groups: 'Grouped list',
    fields: 'Fields',
    status: 'Status',
    empty: 'Empty state',
    icons: 'Icon vocabulary',
    dialog: 'Confirmation dialog',
    primary: 'Save',
    secondary: 'Cancel',
    plain: 'Learn more',
    danger: 'Delete…',
    dangerFilled: 'Delete',
    withIcon: 'New document',
    loading: 'Saving',
    disabled: 'Disabled',
    refresh: 'Refresh',
    download: 'Download',
    share: 'Share',
    pinned: 'Pinned',
    delete: 'Delete',
    close: 'Close',
    back: 'Back',
    more: 'More',
    openInCortex: 'Open in Cortex',
    documentTitle: 'intro.md',
    groupAppearance: 'Appearance',
    groupNote: '“System” follows your computer’s setting.',
    rowLanguage: 'Interface language',
    rowLanguageValue: 'English',
    rowCompact: 'Compact lists',
    rowNotify: 'Notify when an agent is done',
    rowSignOut: 'Sign out',
    fieldName: 'Project name',
    fieldNameHelp: 'Visible to everyone in the tenant.',
    fieldModel: 'Model',
    fieldModelError: 'This model is not configured.',
    fieldKind: 'Kind',
    fieldNotes: 'Notes',
    fieldAgree: 'Let agents edit this document',
    alertInfo: 'Agents can read this document but not change it.',
    alertWarning: 'Two kits have an update.',
    alertError: 'The connection to the server was lost.',
    alertSuccess: 'Saved.',
    badge: 'Badge',
    emptyHeadline: 'No documents yet',
    emptyBody: 'Create the first one or import a folder.',
    dialogOpen: 'Delete project…',
    dialogTitle: 'Delete “Wedding planning”?',
    dialogBody: 'The project and its 42 documents are removed. This cannot be undone.',
  },
  newVersion: {
    message: 'A newer version of Vance is available.',
    action: 'Reload',
    dismiss: 'Later',
  },
  projectStatus: {
    liveLabel: 'Live state',
    runnerLabel: 'Runner',
    state: {
      UNKNOWN: 'Status unknown',
      STOPPED: 'Stopped',
      STARTING: 'Starting',
      RUNNING: 'Running',
      STOPPING: 'Stopping',
    },
    runner: {
      UNKNOWN: 'unknown',
      PENDING: 'starting',
      READY: 'ready',
      FAILED: 'failed',
      DISABLED: 'off',
    },
  },
  common: {
    expand: 'Expand',
    collapse: 'Collapse',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Saved.',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    loading: 'Loading…',
    signOut: 'Sign out',
    signIn: 'Sign in',
    profile: 'Profile',
    settings: 'Settings',
    connectedApps: 'Apps with access',
    home: 'Home',
    backToHome: 'Back to home',
    projectPicker: {
      addGroup: 'Add group',
      addProject: 'Add project',
      addProjectToGroup: 'Add project to this group',
      collapseGroup: 'Collapse group',
      expandGroup: 'Expand group',
      createGroup: {
        title: 'New project group',
        name: 'Name',
        nameHelp: 'Lower-case letters, digits, "-" or "_". Unique inside the tenant.',
        titleLabel: 'Title',
        submit: 'Create',
      },
      createProject: {
        title: 'New project',
        name: 'Name',
        nameHelp: 'Lower-case letters, digits, "-" or "_". Unique inside the tenant.',
        titleLabel: 'Title',
        group: 'Group',
        groupNone: 'No group',
        kit: 'Kit',
        kitNone: 'No kit',
        kitHelp: 'Pre-configured project starter — installs documents, settings and tools right after create.',
        kitCatalog: 'Kit from the catalog',
        kitCatalogEmpty:
          'This tenant has no kit catalog configured. Use one of the other tabs, or '
          + 'ask an admin to fill the catalog.',
        tabCatalog: 'Catalog',
        tabProject: 'From project',
        tabManual: 'Manual',
        kitProject: 'Kit from a project',
        kitProjectHelp:
          'Projects of this tenant that are kit sources themselves — for a kit being '
          + 'authored here that is not in the catalog yet.',
        kitProjectLoading: 'Loading projects…',
        kitProjectEmpty:
          'No project of this tenant is a kit source right now. A project becomes one '
          + 'via "Develop this kit" on its project card.',
        kitUrl: 'Kit URL',
        kitUrlHelp: 'https://… or file:///… — project:<name> works too.',
        kitPath: 'Sub-path',
        kitPathHelp: 'Optional. Defaults to the repo root.',
        kitBranch: 'Branch',
        kitBranchHelp:
          'Optional, defaults to main. No token or vault password here — install a '
          + 'private repo afterwards from the project card.',
        submit: 'Create',
      },
      error: {
        forbidden: 'This action requires tenant-admin access.',
        invalidInput: 'Invalid input: {message}',
        generic: 'Error: {message}',
      },
    },
    confirm: 'Confirm',
    archive: 'Archive',
    remove: 'Remove',
  },

  fook: {
    menuLabel: 'Report a bug / feature',
    title: 'Report a bug or request a feature',
    intro:
      'Describe concretely what happened, what you expected, or what you wish Vancetope did. '
      + 'Fook takes type, severity and title from your text and sends the outcome to your inbox.',
    placeholder:
      'What went wrong, or what would you want to change? Steps to reproduce help.',
    sessionAccess:
      'Allow Fook to read this session (adds the session id to the ticket and lets Fook analyse it)',
    submit: 'Submit',
    submitted: 'Submitted — Fook is triaging. Submission id:',
    errorEmpty: 'Please describe the issue or request before submitting.',
    errorGeneric: 'Submission failed. Please try again or contact an admin.',
  },

  reconnect: {
    title: 'Connection lost',
    attempting: 'Trying to restore the connection… (attempt {n}/{total})',
    giveUp: 'The connection could not be restored automatically.',
    tryAgain: 'Try again',
  },
  sessionTakeover: {
    title: 'Session open elsewhere',
    body: 'This session is currently open in another window or on another '
      + 'device. You can take it over here — the other connection will be '
      + 'disconnected.',
    takeOver: 'Take over here',
    cancel: 'Cancel',
    failed: 'Could not take over the session. Please try again.',
  },

  documentPresence: {
    tooltip: '{n} other viewer(s) of this document',
  },

  processPanel: {
    title: 'Processes of this session',
    count: '{n} process(es)',
    closeReason: {
      DONE: 'done',
      INCOMPLETE: 'incomplete',
      STOPPED: 'stopped',
      STALE: 'stale',
      ARCHIVED: 'archived',
      USER_DELETE: 'deleted',
      ABANDONED: 'abandoned',
      AUTO_CLOSE: 'auto-closed',
    },
    empty: 'No processes',
    pickOne: 'Pick a process',
    loading: 'Loading …',
    silent: "No messages yet — the process hasn't spoken.",
    olderTruncated: '… {n} older message(s) not shown',
    steer: 'Send',
    steerPlaceholder: 'Message to the process …',
    pause: 'Pause',
    resume: 'Resume',
    stop: 'Stop',
    reload: 'Reload',
    sent: 'Debackuped.',
    queuedBusy: 'Queued — the process is working and will pick it up after its '
      + 'current turn.',
    done: 'Done.',
    loadFailed: 'Loading failed.',
    actionFailed: 'Action failed.',
    noConnection: 'No connection — processes are only visible with a bound session.',
    previewTitle: 'Processes — {session}',
    previewReadOnly: 'Preview of a session you are not in — read-only.',
    openSession: 'Open session',
    segmentLive: 'Live',
    segmentAll: 'All',
    filterLabel: 'Show processes',
  },

  cortex: {
    confirmDiscardUnsaved: '“{label}” could not be saved ({reason}).\n\nClose anyway and discard the changes?',
    noAddon: 'No addon specified (?addon=<id> required).',
    occupied: 'Another connection holds this session — close that tab and retry.',
    sessionNotFound: 'Session {id} not found.',
    accessDenied: 'Access to this session was denied.',
    bindUnbound: 'unbound',
    bindAuto: 'auto',
    bindAutoWithPath: 'auto · {path}',
    bindPinnedClosed: 'pinned (closed)',
    bindOffTooltip: 'Chat is not bound to any document. Switch via the Chat menu.',
    bindAutoTooltip:
      'Auto: chat follows the current tab ({path}); your text selection is sent too. '
      + 'Switch via the Chat menu.',
    bindAutoTooltipEmpty: 'Auto: chat follows the current tab. Open a document to bind it.',
    bindPinnedTooltip: 'Pinned: chat is bound to {path}. Switch via the Chat menu.',
    bindPinnedTooltipClosed:
      'Pinned document is closed — reopen it or switch mode via the Chat menu.',
    confirmDelete: 'Delete this document?',
    leaveChat: 'Leave chat',
    descriptionRequired: 'Description required',
    pathRequired: 'Path required',
    overrideNotObject: 'Override must be a JSON object',
    menu: {
      file: 'File',
      newFile: 'New file…',
      newMarkdown: 'New Markdown file…',
      duplicate: 'Duplicate',
      rename: 'Rename…',
      newFolder: 'New folder…',
      open: 'Open…',
      save: 'Save',
      saveAll: 'Save all',
      exportPdf: 'Export PDF…',
      closeTab: 'Close tab',
      view: 'View',
      autoReveal: 'Auto — reveal active file in tree',
      autoComplete: 'Auto — suggest completions on idle',
      actions: 'Actions',
      ageEncrypt: 'Encrypt…',
      ageDecrypt: 'Decrypt…',
      extras: 'Extras',
      chat: 'Chat',
      autoFollow: 'Auto — follow current tab',
      pinToTab: 'Pin to current tab',
      unbindChat: 'Unbind chat',
      agentEditing: 'agent editing…',
      agentEditingTitle: 'An agent tool is currently editing the chat-bound document',
      noDocumentHeadline: 'No document open',
      noDocumentBody: 'Pick one from the tree on the left, or create a new file.',
    },
    compose: {
      loading: 'Loading…',
      loadingAnswer: 'Loading answer…',
      noAnswer: 'The agent produced no answer.',
      stopping: 'stopping…',
    },
    hactar: {
      applyToEditor: 'Apply to editor',
      thinking: 'Slart is thinking…',
      generatedScript: 'Generated script',
      regenerate: 'Re-generate',
      failed: 'FAILED:',
      close: 'Close',
      titleUpdate: 'Slart · update this script',
      titleGenerate: 'Slart · generate a new script',
      update: 'Update',
      generate: 'Generate',
      updateDescription: 'Slart sees the current script body and preserves its structure where possible. The new version lands in a fresh Slart bucket — the original document only changes if you click {apply}.',
      promptLabelUpdate: 'What should change?',
      promptLabelGenerate: 'What should the script do?',
      promptPlaceholderUpdate: "Example: 'Also send a Slack notification when the inbox is empty.'",
      promptPlaceholderGenerate: "Example: 'Read a number from args.n and return its factorial.'",
    },
    rightPanel: {
      title: 'Right panel',
      chat: 'Chat',
      help: 'Help',
    },
    validate: {
      cachedDeep: 'Cached Deep Review',
      noIssuesFound: '✓ no issues found',
      title: 'validate',
      quickRunning: 'quick running…',
      deepRunning: 'deep review running…',
      close: 'Close validate panel',
      quick: 'Quick:',
      noParseErrors: '✓ no parse errors',
      deep: 'Deep Review:',
      matchesCurrent: '(matches current)',
      contentChanged: '(content has changed since)',
      noIssues: '✓ no issues flagged',
      noResult: '(no validation result yet)',
    },
    create: {
      cancel: 'Cancel',
      create: 'Create',
    },
    notes: {
      lineShort: 'Line {line}',
      empty: 'No notes. Click next to a line number or the ＋ button.',
      jumpToLine: 'Jump to line {line}',
      title: 'Notes',
      newNote: 'New note',
      dragToMove: 'Drag to move',
      delete: 'Delete',
    },
    properties: {
      tabGeneral: 'Properties',
      tabDetails: 'Details',
      tabVersions: 'Versions',
      name: 'Name',
      namePlaceholder: 'filename',
      title: 'Title',
      titlePlaceholder: '(no title)',
      tags: 'Tags',
      tagsPlaceholder: 'comma, separated',
      mime: 'MIME',
      color: 'Color',
      lock: 'Lock (soft edit-protection)',
      lockAi: 'AI',
      lockAiTitle: 'Block LLM / tool writes',
      lockUser: 'USER',
      lockUserTitle: 'Block manual user writes',
      lockKit: 'KIT',
      lockKitTitle: 'Freeze against Kit-Apply updates',
      save: 'Save properties',
      path: 'Path',
      kind: 'Kind',
      size: 'Size',
      created: 'Created',
      by: 'By',
      headers: 'Headers',
      summary: 'Summary',
    },
    shell: {
      view: 'View',
      viewMode: 'View mode',
      download: 'Download {name}',
      hideProperties: 'Hide properties',
      showProperties: 'Show properties',
      hideNotes: 'Hide notes',
      showNotes: 'Show notes',
      validate: 'Validate',
      deepReviewLabel: 'Deep Review',
      argsHint: "JSON args object, default `{'{'}{'}'}`",
      runTitle: '{label} — execute the document',
      noLogOutput: '(no log output yet)',
      appEditToggle: 'App / edit toggle',
      appView: 'App view',
      app: 'App',
      rawManifest: 'Raw YAML manifest editor',
      reload: 'Reload from server',
      reloadDirty: 'Reload (discards unsaved changes)',
      viewEditToggle: 'View / edit toggle',
      renderedView: 'Rendered view',
      unsaved: 'Unsaved changes',
      edit: 'Edit',
      rawSource: 'Raw source editor',
      cancelRun: 'Cancel the running execution',
      cancelRunLabel: 'Cancel',
      quickValidate: 'Quick validate — parse + header check',
      deepReview: 'Deep review — LLM static review (slow, cached server-side)',
      generateScript: 'Generate a new script from a free-text description (Slart SCRIPT_JS)',
      generate: 'Generate',
      updateScript:
        'Update this script — describe the change and Slart rewrites it preserving structure',
      update: 'Update',
      properties: 'Properties',
      path: 'Path:',
      mime: 'MIME:',
      readOnly: 'read-only',
      closeLog: 'Close log panel',
      result: 'result:',
      reloadDirtyTitle: 'Discard unsaved changes?',
      reloadDirtyMessage: 'Reloading {path} replaces your unsaved edits with the stored version.',
    },
    age: {
      save: 'Save',
      saveTitle: 'Encrypt with the session key and save (age)',
      lockedTitle: 'This document is age-encrypted',
      lockedBody:
        'The server stores ciphertext only — the plaintext exists solely in your client. '
        + 'Import the key it was encrypted with to read and edit the document.',
      unlockTitle: 'Unlock with a key',
      identityLabel: 'Identity',
      identityFileLabel: 'Import identity file…',
      passphraseLabel: 'Passphrase',
      unlock: 'Unlock',
      tryAgain: 'Try again',
      forget: 'Forget keys',
      forgetDirtyWarning:
        'An encrypted document with unsaved edits is open — without a key it cannot be saved '
        + 'until you re-import one. Forget anyway?',
      keyCount: '{identities} identities, {passphrases} passphrases held this session',
      memoryHint:
        'Keys stay in this browser tab’s memory only — never on the server, never on disk. '
        + 'A reload asks again.',
      emptyForm: 'Paste an identity (AGE-SECRET-KEY-1…) or enter a passphrase first.',
      wrongKey: 'None of the held keys fit this document.',
      notArmored:
        'The stored body is not armored age ciphertext — the document is corrupt or was '
        + 'stored wrongly.',
      cipherPreview: 'Ciphertext preview',
      embedded: 'This document is age-encrypted — open it in Cortex to unlock.',
      transform: {
        encryptTitle: 'Encrypt document',
        decryptTitle: 'Decrypt document',
        intro: 'A new document is created at the target path — the original stays untouched. Tidy up yourself when the result looks right.',
        targetLabel: 'New document path',
        targetHelp: 'Same folder as the source by default.',
        dirtyHint:
          'The open tab has unsaved edits — they are not part of the stored document and '
          + 'therefore not part of the result. Save first if you want them included.',
        keySection: 'Key',
        keyIdentities: 'My session identities ({n})',
        keyPassphrase: 'A passphrase',
        identitiesInfo: 'Encrypting to your {n} session identities — every one of them can decrypt.',
        addIdentity: 'Add identity',
        generate: 'Generate a new key',
        generatedWarning:
          'New key generated — it lives in this browser tab’s memory only. Download it now: '
          + 'without the file, the document cannot be decrypted later.',
        downloadKey: 'Download key file',
        passphraseCostHint:
          'Share the passphrase out-of-band; every save of the encrypted document re-runs '
          + 'the key derivation (a few seconds).',
        confirmEncrypt: 'Encrypt',
        confirmDecrypt: 'Decrypt',
      },
    },
    tabs: {
      empty: 'No documents open — pick one from the tree, or create a new file.',
      close: 'close',
    },
    tree: {
      documents: 'Documents',
      reveal: 'Reveal active file in tree',
      reload: 'Reload document tree',
      loading: 'loading',
      loadingText: 'loading…',
      delete: 'Delete',
      empty: 'empty',
    },
    renameDocument: {
      failed: 'Rename failed',
    },
    newMarkdown: {
      title: 'New Markdown file',
      pathLabel: 'Folder',
      pathPlaceholder: 'documents/notes',
      nameLabel: 'Name',
      namePlaceholder: 'meeting-notes',
      nameHelp: 'Leave empty for note1.md, note2.md, …',
      failed: 'Create failed',
      invalidName: 'Enter a file name, not a folder (it must not end with "/").',
      cancel: 'Cancel',
      create: 'Create',
    },
    newFolder: {
      title: 'New folder',
      pathLabel: 'Folder path',
      pathPlaceholder: 'documents/notes',
      cancel: 'Cancel',
      create: 'Create',
      description: 'Folders are virtual until a file lives in them — this entry is client-side and disappears on refresh unless something gets moved into it.',
    },
    openDocument: {
      title: 'Open document',
      searchPlaceholder: 'Search by path or title…',
      searching: 'Searching…',
      noResults: 'No matching documents.',
      truncated: 'Showing {shown} of {total} — refine the search.',
    },
    tex: {
      previewHint: 'KaTeX preview — for full layout use "Generate PDF"',
    },
    backToDocuments: 'Back to documents',
    backToChat: 'Back to chat',
    translate: {
      menuDocument: 'Translate…',
      menuSelection: 'Translate selection…',
      title: 'Translate “{name}”',
      titleSelection: 'Translate selection',
      languageLabel: 'Target language',
      customLanguage: 'Other language…',
      customLanguageLabel: 'Language',
      customLanguagePlaceholder: 'e.g. Brazilian Portuguese, plain English',
      targetNameLabel: 'New file name',
      targetNameHelp: 'Created in the same folder as the original.',
      sourceInfo: '{chars} characters will be translated in one pass.',
      submit: 'Translate',
      cancel: 'Cancel',
      close: 'Close',
      copy: 'Copy to clipboard',
      copied: 'Copied',
      resultLabel: 'Translation',
      failed: 'Translation failed.',
      emptyResult: 'The model returned nothing.',
      maybeTruncated: 'The translation is much shorter than the source — it may be incomplete.',
      tooLong: 'Too long for one pass: {length} characters, limit {max}. Translate a selection instead.',
    },
  },

  cortexThreads: {
    tab: 'Discussion',
    heading: 'Discussions on',
    noDocument: 'Open a document to see the discussions about it.',
    loading: 'Loading…',
    emptyHeadline: 'No discussions',
    emptyBody: 'Nothing has been raised about this document.',
    noTitle: '(no title)',
    awaitingAnswer: 'waiting for an answer',
    answerInInbox: 'Answer this in your inbox ↗',
    newTitle: 'Open a discussion',
    newIntro: 'A new thread about “{doc}”. Anyone taking part can contribute to it.',
    newTitleLabel: 'Subject',
    newAssignee: 'On whose desk',
    assignSelf: 'Mine',
    newBody: 'What is it about? (optional)',
    newCancel: 'Cancel',
    newConfirm: 'Open',
    backToList: 'Back to the list',
    truncated: 'Showing the newest {count} — older discussions are not listed.',
  },
  inboxThread: {
    addReaction: 'Add a reaction',
    reason: {
      assignee_must_stay: 'You are the assignee of this open ask — delegate it instead of unsubscribing.',
      message_limit_reached: 'This thread has reached its message limit. Open a new thread for what is left.',
      invalid_parent: 'That message cannot be replied to — replies go one level deep.',
      participant_must_stay: 'This person cannot be removed — they are the assignee of the open ask, or they opened the thread.',
      reaction_limit_reached: 'There are enough different reactions here already — join one of them.',
    },
    participants: 'Taking part:',
    team: '(team {team})',
    follow: 'Following',
    followTitle: 'Receive updates on this thread',
    reply: 'Reply',
    replyingTo: 'Replying to a message',
    cancelReply: 'cancel',
    newFromHere: 'new from here',
    readBy: 'read: {names}',
    unread: 'unread',
    empty: 'No discussion yet — ask if something is unclear.',
    placeholder: 'Add to the discussion…',
    send: 'Send',
    invite: 'Invite',
    invitePlaceholder: 'user to invite',
    remove: 'Remove',
    picked: 'picked',
    removeTitle: 'Remove {name} from the thread',
  },

  inboxBadge: {
    tooltip: '{n} unread — {p} open in total; open the inbox',
    actionableTooltip: '{n} unread, {a} waiting for your answer — {p} open in total; open the inbox',
  },

  processCounts: {
    emptyTooltip: 'No other processes — open the list',
    label: '{n} process(es)',
    tooltip: '{running} running · {waiting} waiting · {blocked} blocked',
    blockedHint: '{n} process(es) waiting for you',
  },

  workingProject: {
    tooltip: 'Hub focus project — actions without an explicit project land in “{name}”',
  },

  header: {
    connection: {
      connected: 'Connected — live',
      occupied: 'Session is occupied by another connection',
      idle: 'Pick a session to start',
      reconnecting: 'Connection paused — will reconnect on next send',
    },
    menu: {
      languageHeader: 'Language',
      switchAccount: 'Switch account',
      manageAccounts: 'Manage accounts',
      addAccount: 'Add account',
    },
    help: {
      toggle: 'Toggle help',
      title: 'Help',
      close: 'Close help',
      loading: 'Loading help …',
      unavailable: 'Help unavailable: {error}',
      empty: 'No help available for this page yet.',
    },
  },

  login: {
    license: 'Open source under the GNU AGPLv3',
    sourceCode: 'Source code',
    autoLoginNotice: 'You have been signed in',
    invalidCredentials: 'Invalid credentials.',
    loginFailed: 'Login failed.',
    loginFailedWithStatus: 'Login failed with status {status}.',
    autoLoginFailed: 'Auto-login failed. Please sign in again.',
    openInApp: {
      message: 'Vance has a native iOS app',
      action: 'Open',
    },
    tenant: 'Tenant',
    username: 'Username',
    password: 'Password',
    rememberUser: 'Remember user',
    continue: 'Continue',
    emailToken: {
      sendCode: 'Send code',
      sent: 'If this account can sign in by e-mail, a code was sent to the address on file. It is valid for {minutes} minutes.',
      code: 'Code from the e-mail',
      invalidCode: 'The code is wrong or has expired. Request a new one.',
      reference: 'Reference: {id}. Use the code from the e-mail with this same reference; a newer code makes the older one void.',
      tooMany: 'Too many requests. Please wait a few minutes.',
      startFailed: 'The code could not be requested. Please try again.',
      back: 'Back',
      resend: 'Send a new code',
      resendIn: 'Send a new code in {seconds} s',
    },
    sso: {
      email: 'Work e-mail address',
      continueWithGoogle: 'Continue with Google',
      or: 'or',
      emailRequired: 'Enter your work e-mail address to continue with Google.',
      notAvailable: 'This address cannot sign in with Google here. Use tenant, username and password instead.',
      rejected: 'Your account is not enabled for sign-in with Google. Ask your administrator.',
      noSeats: 'This workspace has no free seats left. Ask your administrator.',
      failed: 'Sign-in with Google did not complete. Please try again.',
    },
  },

  index: {
    sectionTitle: 'Editors',
    chat: {
      title: 'Chat',
      description:
        'Live chat with the brain over WebSocket. Pick an existing session or start a new one in any project.',
      llmNotConfigured:
        'This tenant has no default language model (ai.default.provider / ai.default.model). Chats fail unless their project sets its own model or an admin sets a tenant default.',
      llmPowerOff:
        'LLM access for this tenant is switched off.',
      llmBudgetPercent:
        'LLM budget: {percent}% used.',
    },
    documents: {
      title: 'Documents',
      description: 'Browse and edit project documents.',
      storageQuota:
        'Storage: {percent}% used ({bytesFree} free).',
    },
    inbox: {
      title: 'Inbox',
      description:
        "Read items from your personal inbox and the team-inbox of every team you're in. Reply, archive, delegate.",
    },
    insights: {
      title: 'Insights',
      description:
        'Inspect sessions, think-processes, chat history, memory and Marvin trees. Read-only diagnostic view.',
    },
    runs: {
      title: 'Runs',
      description:
        'Running and finished instances of every runtime in a project: Magrathea workflows, plan-shaped think-processes, compose runs.',
    },
    users: {
      title: 'Users & Teams',
      description:
        'Manage tenant users (create, password reset, status) and teams (members, enabled flag).',
    },
    open: 'Open',
  },

  chat: {
    pageTitle: 'Chat',
    openCortex: 'Open Cortex',
    composer: {
      showTools: 'Show tools',
      hideTools: 'Hide tools',
    },
    modelPicker: {
      button: 'Model and reasoning',
      buttonState: 'Model: {model} · reasoning: {level}',
      title: 'Model and reasoning',
      description: 'Applies to this chat from the next turn. New chats start with the recipe default again.',
      filter: 'Filter models…',
      loading: 'Loading models…',
      recipeDefault: 'Recipe default',
      noModels: 'No matching models',
      noModelsBody: 'Change the filter, or ask an admin which models are allowed here.',
      small: 'small',
      large: 'large',
      context: '{n} context',
      reasoning: 'reasoning',
      noPrice: 'no price',
      reasoningLevel: 'Reasoning level',
      noReasoning: 'This model has no adjustable reasoning.',
      cancel: 'Cancel',
      apply: 'Apply',
      commandFailed: '//{verb} failed',
      modelError: 'The current model cannot be used: {error} — pick another model or the recipe default.',
      level: {
        off: 'Off',
        minimal: 'Minimal',
        low: 'Low',
        medium: 'Medium',
        high: 'High',
      },
    },
    breadcrumb: {
      unnamedSession: 'Session',
    },
    backToSessions: '← Sessions',
    connecting: 'Connecting to brain…',
    confirmLeave:
      'Leave this chat session? The connection will be released and any unsent draft is lost.',
    pickAnotherSession: 'Pick another session',
    tryAgain: 'Try again',
    backToPicker: 'Back to picker',
    historyLoading: 'Loading history…',
    composerPlaceholderSingle: 'Message',
    composerPlaceholderMulti: 'Message',
    followUp: {
      acceptHint: 'press Space',
      acceptTooltip: 'Press Space, Tab, or click to use this follow-up',
    },
    send: 'Send',
    pause: 'Pause',
    pauseTooltip: 'Pause the chat and all workers (Esc) — always available, the engine decides what is interruptible',
    pauseFailed: 'Pause failed.',
    multilineToggleSingle: 'Switch to single-line input',
    multilineToggleMulti: 'Switch to multi-line input',
    historyTitle: 'Input history',
    historyHint: '↑/↓ browse · ⏎ insert · Esc close',
    failedToOpen: 'Failed to open WebSocket.',
    failedToResume: 'Failed to resume session.',
    failedToSend: 'Failed to send.',
    queuedBadge: 'Queued — the engine picks it up at its next loop boundary.',
    connectionLost: 'Connection lost. Reload to reconnect.',
    connectionClosed: 'Connection closed.',
    sessionOccupiedBy: 'Session "{id}" is held by another connection.',
    sessionNotFound: 'Session "{id}" no longer exists. Pick another.',
    mediation: {
      banner: 'Direct connection with the agent in {project} — type /hub or use the button to return.',
      backToHub: 'Back to hub',
    },
    sessionForbidden: 'Session "{id}" belongs to another user.',
    attachments: {
      pickerTooltip: 'Attach a file (or drop one onto the message box)',
      pickFromComputer: 'From computer…',
      attachCurrentFile: 'Current file',
      dropToAttach: 'Drop to attach',
      remove: 'Remove attachment',
    },
    speech: {
      startSpeechToText: 'Start speech-to-text',
      stopSpeechToText: 'Stop speech-to-text',
      muteIncoming: 'Mute incoming messages',
      readAloud: 'Read incoming messages aloud',
      settings: 'Speech settings',
      language: 'Language',
      voice: 'Voice',
      voiceAuto: 'Auto (default voice for language)',
      voiceDefaultSuffix: ' · default',
      rate: 'Rate',
      volume: 'Volume',
      savedLocally:
        'Saved locally. Used by the chat speaker now and any future read-aloud feature.',
      microphoneError: 'Microphone error: {error}',
      recordStartFailed: 'Failed to start recording.',
      talkModeStart: 'Start talk mode (hands-free — speech accumulates, say "Computer send" to submit)',
      talkModeStop: 'Stop talk mode',
      talkModeIdleOff: 'Talk mode stopped due to inactivity.',
      talkModePaused: 'Talk mode paused — say "Computer resume" to continue.',
      talkModePausedHint: 'Talk mode paused (tap to stop; say "Computer resume" to continue)',
      talkModeListening: 'Sent — the reply is being read aloud. Say "Computer resume" to dictate again.',
      talkModeListeningHint: 'Talk mode listening (dictation off, reply read aloud; say "Computer resume" to continue)',
    },
    bubble: {
      copy: 'Copy as Markdown',
      copyDone: 'Copied',
      thoughts: 'Thoughts',
    },
    export: {
      saveAsDocumentTooltip:
        'Save this conversation as a Markdown document in the chat\'s project (auto-summary and RAG indexing off by default).',
      saveAsDocumentLabel: 'Save as document',
      saveSucceeded: 'Saved to {path}',
      saveFailed: 'Failed to save the conversation as a document.',
    },
    activity: {
      joined: 'joined',
      left: 'left',
      whoHeader: 'In the room:',
      whoEmpty: 'no one',
      whoFailed: '/who failed',
    },
    autoAi: {
      placeholder: '🤖 Auto-AI on — message (start with @no to skip the AI)',
      statusOn: 'Auto-AI: ON — every message goes to the AI (escape with @no)',
      statusOff: 'Auto-AI: OFF — type @ai to address the agent',
    },
    sessionHeader: {
      untitled: 'Untitled',
      editTitlePlaceholder: 'Session title…',
      iconLabel: 'Icon',
      colorLabel: 'Accent color',
      pinTooltip: 'Pin session',
      unpinTooltip: 'Unpin session',
      collabEnableLabel: 'Allow multiple participants',
      collabDisableLabel: 'Make private (1:1 again)',
      archiveTooltip: 'Archive session',
      archive: 'Archive',
      archiveConfirm:
        'Archive this session now? The chat is preserved and can be reactivated later.',
      reactivate: 'Reactivate',
      reactivateConfirm:
        'Reactivate this archived session? A fresh engine spins up on top of the existing conversation.',
      delete: 'Delete',
      deleteConfirm:
        'Permanently delete this session? All messages and metadata will be lost.',
      archived: 'Archived',
      autoTitle: 'Auto title',
      autoTitleBadge: 'AI',
      saveError: 'Could not save change.',
      tagsLabel: 'Tags',
      tagsTooltip: 'Edit tags',
      tagsPlaceholder: 'Add tag…',
      moreActions: 'More actions',
      duplicate: 'Duplicate',
      duplicateTitlePrefix: 'Copy of {title}',
      duplicateFallbackTitle: 'Copy',
      duplicateError: 'Could not duplicate the session.',
      move: 'Move to project…',
      moveTitle: 'Move session to another project',
      moveTargetLabel: 'Target project',
      moveTargetPlaceholder: 'Choose a project…',
      moveNoProjects: 'No other project available to move into.',
      moveWarning:
        'The session loses the memory it built up in this project (RAG and memories are not carried over and are deleted from the old project), and it is removed from its session group. This cannot be undone.',
      moveConfirm: 'Move',
      moveCancel: 'Cancel',
      moveError: 'Could not move the session.',
      moveBusyError:
        'This session is currently running — stop the active turn before moving it.',
      crop: 'Crop',
      compact: 'Compact',
      compactConnectedConfirm: 'This session is currently connected — someone may be working on it. Compact its memory now anyway? Compaction runs safely between turns.',
      compactDone: 'Compacted: {n} message(s) folded into a summary.',
      compactNothing: 'Nothing to compact — the memory is already compact.',
      compactDeferred: 'Compaction queued — it will run after the current turn.',
      compactError: 'Compaction failed.',
    },
    crop: {
      title: 'Crop session',
      description: 'Remove messages from memory. Removed messages stay in the database but are invisible to the AI — restorable at any time.',
      connectedConfirm: 'This session is currently connected — someone may be working on it. Crop its memory anyway?',
      loading: 'Loading messages…',
      empty: 'No messages in this session.',
      loadError: 'Could not load messages.',
      applyError: 'Could not save changes.',
      removedBadge: 'Removed',
      willRemove: 'will be removed',
      willRestore: 'will be restored',
      cropFromHere: 'Crop from here',
      undoCrop: 'Clear selection',
      apply: 'Apply',
      cancel: 'Close',
      pendingNone: 'No changes',
      pending: '{n} change(s)',
      removeToggle: 'Remove from memory',
      roleUser: 'User',
      roleAssistant: 'AI',
      roleSystem: 'System',
    },
    clients: {
      heading: 'Running CLI clients',
      refresh: 'Refresh',
      emptyTitle: 'No running clients',
      emptyHint: 'A vancetope CLI announces itself here while it runs. '
        + 'Start it with --remote-control to allow input from here right away.',
      podLocalOnly: 'Only clients connected to this server node are listed '
        + '(cross-node listing needs Redis).',
      busy: 'busy',
      fullscreen: 'fullscreen UI',
      noSession: 'no session bound',
      stateLine: 'Connection: {connection} · UI: {ui}',
      pause: 'Pause',
      stop: 'Stop',
      detach: 'Detach',
      gap: 'Some output was lost — the client could not replay that far back.',
      noOutput: 'No output yet.',
      inputPlaceholder: 'Type a line — commands start with /',
      inputBlocked: 'Input is blocked on this client',
      send: 'Send',
    },
    picker: {
      tabs: {
        sessions: 'Sessions',
        clients: 'Clients',
        label: 'View',
      },
      projectsTitle: 'Projects',
      loading: 'Loading…',
      ungrouped: 'Ungrouped',
      noProjects: 'No projects yet',
      noProjectsBody: 'Ask an admin to create a project.',
      pickAProject: 'Pick a project',
      signedInAs: 'Signed in as {username}',
      newSession: 'New session',
      sessionsLoading: 'Loading sessions…',
      budgetBanner: {
        label: 'LLM budget:',
        scopeTenant: 'tenant',
        scopeProject: 'project {project}',
      },
      noSessions: 'No sessions in this project',
      noSessionsBody: "Click 'New session' to start one.",
      occupied: 'occupied',
      occupiedTooltip: 'Occupied by another connection',
      sharedTooltip: 'Shared session — you can join',
      processesTooltip: 'Peek at this session’s processes — without opening it',
      joinLive: 'live · join',
      hijackConfirm:
        'This session is already held by another of your tabs. '
        + 'Take it over and disconnect the other one?',
      available: 'Available',
      failedToLoadSessions: 'Failed to load sessions.',
      failedToStartSession: 'Failed to start a new session.',
      relativeJustNow: 'just now',
      relativeMinutes: '{n}m ago',
      relativeHours: '{n}h ago',
      relativeDays: '{n}d ago',
      searchTooltip: 'Search sessions (Cmd/Ctrl-K)',
      showArchived: 'Show archived',
      filterPlaceholder: 'Filter projects…',
      filterNoMatch: 'No projects match "{filter}".',
      sessionFilterPlaceholder: 'Filter sessions…',
      sessionFilterNoMatch: 'No sessions match "{filter}".',
      recipeModalTitle: 'Start new session',
      recipeModalIntro: 'Pick a recipe for the new session. "Default" uses the project default.',
      recipeDefaultName: 'Default',
      recipeDefaultDescription: 'Use the project default recipe — same as starting without picking one.',
      recipeLoadFailed: 'Failed to load recipes.',
      recipeCategoryOther: 'Other',
      recipeFilterPlaceholder: 'Filter recipes…',
      recipeFilterNoMatch: 'No recipes match "{filter}".',
      recipeBadgeTooltip: 'Recipe of the session-chat process',
      groups: {
        createTooltip: 'Create session group',
        createTitle: 'Create session group',
        nameLabel: 'Name',
        nameHint: 'Automatically normalised to lower-case.',
        titleLabel: 'Title (optional)',
        add: 'Create',
        ungrouped: 'Ungrouped',
        moveUp: 'Move up',
        moveDown: 'Move down',
        delete: 'Delete group',
        confirmDelete: 'Delete group "{name}"? Its sessions are only removed from the group, not deleted.',
        emptyDropHint: 'Drag a session here',
        newGroup: 'New group…',
      },
      newSessionEllipsis: 'New session…',
    },
    search: {
      title: 'Search sessions',
      placeholder: 'Title, tag, or chat content…',
      scopeBoth: 'Both',
      scopeMetadata: 'Title & tags',
      scopeContent: 'Chat content',
      includeArchived: 'Include archived',
      empty: 'Nothing searched yet',
      emptyBody: 'Type above to search session titles, tags, or chat content.',
      noResults: 'No matches',
      noResultsBody: 'Try a different term or widen the scope.',
      headlineMetadata: 'Title & tag matches',
      headlineContent: 'Chat matches',
      open: 'Open',
      preview: 'Chat preview',
      previewLoading: 'Loading preview…',
      previewError: 'Could not load preview.',
      previewClose: 'Close',
      failed: 'Search failed.',
    },
    progress: {
      title: 'Live progress',
      empty: 'No progress yet',
      emptyBody: 'Live status from running processes shows up here.',
      metricsLine: '{calls} calls · {tokensIn}k in / {tokensOut}k out',
      metricsLabel: 'metrics',
      planUpdated: 'plan updated',
      status: 'status',
    },
    wizards: {
      tabLabel: 'Wizards',
      progressTabLabel: 'Progress',
      title: 'Wizards',
      emptyHeadline: 'No wizards available',
      emptyBody:
        'Wizards are YAML forms under _vance/wizards/ that turn into structured prompts.',
      submit: 'Generate prompt',
      refresh: 'Refresh the list',
      back: 'Back to the list',
    },
    skills: {
      tabLabel: 'Skills',
      title: 'Skills',
      categoryOther: 'Other',
      activeBadge: 'active',
      oneShotBadge: 'one-shot',
      refresh: 'Refresh list',
      play: 'Write into the composer',
      clear: 'Deactivate skill',
      recipeBoundTitle: 'Bundled by the recipe — stays active for the process lifetime',
      info: 'Show details',
      macroBadge: 'macro',
      turnBadge: 'one task',
      stickyBadge: 'sticky',
      modeLabel: 'Activation',
      modeHidden: 'Not meaningful (hidden)',
      modeManual: 'Manual',
      modeTrigger: 'Word activation',
      modeAgent: 'AI-driven (Available skills)',
      modeBadgeHidden: 'hidden',
      modeBadgeManual: 'manual',
      modeBadgeTrigger: 'trigger',
      modeBadgeAgent: 'AI',
      notRelevantHint: 'Not relevant for this chat\'s recipe — hidden here, whatever the level says. You can still activate it on purpose.',
      notRelevantTitle: 'hidden — not relevant for this recipe',
      showHiddenTitle: 'Show skills that are not meaningful here ({count} hidden)',
      searchPlaceholder: 'Search skills…',
      modeAuthorHint: 'Set by the skill author — switching it here writes your personal override.',
      modeOverrideHint: 'Personal override (tier: {scope}).',
      lifecycleTurnHint:
        'Applies to one task: active for the next turn, then it clears itself. Add --sticky to keep it.',
      lifecycleStickyHint:
        'Activation persists until the skill is cleared or the session ends — the skill body is injected into every turn.',
      lifecycleShotHint:
        'Fires once as a macro (prompt or configuration) and is never listed as active — there is nothing to clean up.',
      autoTrigger: 'Word triggers:',
      autoTriggerInactive:
        'Word triggers are off on this level — they only fire on "Word activation".',
      autoTriggerTitle:
        'This skill activates itself automatically when a message matches these keywords or patterns.',
      argumentsLabel: 'Arguments',
      requiredLabel: 'required',
      argumentsHint: 'Append as trailing text after the skill name: /skill <name> <values…>',
      toolsLabel: 'Tools',
      manualPathsLabel: 'Contributed manuals',
      referenceDocsLabel: 'Reference docs',
      inlineLabel: 'inline in prompt',
      onDemandLabel: 'on demand (manual_read)',
      scriptsLabel: 'Scripts',
      activateLabel: 'On activation',
      deactivateLabel: 'On deactivation',
      emptyHeadline: 'No skills available',
      emptyBody:
        'Skills are SKILL.md documents in the cascade (user/project/Vance) that get activated on the running process.',
      noProcessHeadline: 'No active process',
      noProcessBody: 'Skills are per-process — start a chat to see the list.',
    },
    planMode: {
      modeBadgeTooltip: 'Current chat-process mode (Arthur Plan-Mode)',
      planTitle: 'Plan',
      planTitleVersioned: 'Plan v{version}',
      awaitingApproval: 'awaiting approval',
      approvalHint: 'Reply with "ok"/"go ahead" to approve, or with corrections.',
      todosTitle: 'Plan steps',
      closedNotice: 'Plan box closed — final state:'
    },
    activityStrip: {
      working: 'working…',
      toolCount: '{count} tools',
      doneTools: '{tools} tools',
      doneWithFailures: '{tools} tools · {failed} failed',
      expand: 'Show activity',
      collapse: 'Hide activity',
    },
  },

  runs: {
    pageTitle: 'Runs',
    refresh: 'Refresh',
    loading: 'Loading runs…',
    loadingDetail: 'Loading run…',
    count: '{n} runs',
    filter: { allSources: 'All sources' },
    action: { PAUSE: 'Pause', RESUME: 'Resume', STOP: 'Stop' },
    link: { definition: 'Open definition', session: 'Open session', document: 'Open document' },
    empty: {
      headline: 'No runs',
      body: 'Nothing is running in this project, and nothing that ran is still being kept.',
    },
    select: {
      headline: 'Pick a run',
      body: 'Choose one on the left to see its steps, variables and result.',
    },
    detail: {
      steps: 'Steps',
      variables: 'Variables',
      children: 'Runs it started',
      result: 'Result',
      source: 'Details ({source})',
      waitingOnInbox: 'This run is waiting for an answer.',
      openInbox: 'Go to inbox',
      composeTransient:
        'Compose runs are kept in memory only — gone ten minutes after they finish, and invisible to another pod.',
    },
  },
  documents: {
    externallyChanged: {
      upserted: 'Changed externally',
      upsertedTooltip: 'Another tab or user just wrote this document. Choose whether to keep your unsaved edits or load the remote version.',
      deleted: 'Deleted externally',
      deletedTooltip: 'This document was deleted on another tab or pod. Choose whether to keep your local copy or accept the deletion.',
      keepLocal: 'Keep mine',
      acceptRemote: 'Use remote',
    },
    recentEditor: {
      tooltip: '{name} just modified this document',
    },
    agentEditing: {
      label: 'AI editing…',
      tooltip: 'An agent in this session is writing on this or another open document.',
    },
    projectsTitle: 'Projects',
    projectFilterPlaceholder: 'Filter projects…',
    projectFilterNoMatch: 'No projects match "{filter}".',
    searchPlaceholder: 'Search documents…',
    pathBack: 'Up one level',
    kits: {
      installed: '{count} kits installed',
      update: 'Update kits',
      updated: '{count} kits updated.',
      updateFailed: 'Kit update failed.',
    },
    title: 'Documents',
    loading: 'Loading documents…',
    totalItems: 'items',
    pagePrevious: 'Previous page',
    pageNext: 'Next page',
    empty: {
      noProjectHeadline: 'No project selected',
      noProjectBody: 'Pick a project on the left to view its documents.',
      folderHeadline: 'No documents',
      folderBody: 'This folder is empty. Drop files here or use “+ New” above.',
      // A mounted folder can be empty for reasons the file list cannot
      // express. "Not found" and "not looked for" must not look alike.
      mountUnreachableHeadline: 'Source is not answering',
      mountUnreachableBody:
        'The mount “{mount}” is configured but currently unreachable: {status}',
      // Folder-scoped and therefore ahead of the mount-wide status: the
      // source may answer perfectly and this one folder still be unreadable
      // (too large to hold, or its last refresh failed).
      mountFolderProblemHeadline: 'This folder could not be read',
      mountFolderProblemBody: '“{mount}”: {reason}',
      mountEmptyBody: 'The external source “{mount}” reports no entries for this folder.',
      mountRetry: 'Try again',
      searchUnsupportedHeadline: 'Nothing was searched here',
      searchUnsupportedBody:
        'The source “{mount}” cannot be searched. Browse the folders instead of concluding from '
        + 'the empty result that the file is missing.',
      searchUnavailableHeadline: 'Search unavailable',
      searchUnavailableBody:
        'The source “{mount}” could not be reached. Trying again may work.',
    },
    mountSearchDelegated:
      'Hits from the external source “{mount}” — they span the whole mount, not just this folder.',
    newDocument: 'New document',
    /** Short form for the toolbar button, where the full label does not fit. */
    addNew: 'New document',
    openCortex: 'Cortex',
    openCortexTitle: 'Open this project in the Cortex editor',
    dropHint: 'Drop files here to upload',
    newFolder: 'New folder',
    newFolderDialog: {
      title: 'Create new folder',
      nameLabel: 'Folder name',
      namePlaceholder: 'e.g. notes or notes/2026',
      nameHelp: 'Created virtually — the folder only exists in storage once the first document is saved inside it. Use slashes for multiple levels (`a/b`).',
      nameRequired: 'Please enter a folder name.',
      create: 'Create',
    },
    ungrouped: 'Ungrouped',
    selection: {
      count: '{count} selected',
      clear: 'Clear selection',
      moveRunning: 'Moved {moved}…',
      moveDone: 'Moved {moved}, skipped {skipped}.',
      trashRunning: 'Trashed {trashed}…',
      trashDone: 'Trashed {trashed}, skipped {skipped}.',
      stop: 'Stop',
      export: 'Export',
      move: 'Move',
      trash: 'Move to trash',
      trashTitle: 'Move to trash',
      trashBody:
        'Move the {count} selected documents to the trash? You can restore them later from the trash, or delete them permanently.',
      moveTitle: 'Move documents',
      moveBody: 'Move {count} selected documents to another folder.',
      moveTargetLabel: 'Target folder',
      folderSuggestionsTruncated:
        'Not every folder is suggested — type the target path if it is missing.',
      customPathPlaceholder: 'e.g. folder/new-folder (free text)',
      moveConfirm: 'Move',
      copy: 'Copy',
      copyTitle: 'Copy documents',
      copyBody: 'Copy {count} selected documents to another project or folder.',
      copyTargetProjectLabel: 'Target project',
      copyTargetFolderLabel: 'Target folder',
      copyCurrentProject: 'Current project',
      copyOverwriteLabel: 'Overwrite existing documents',
      copyOverwriteHelp:
        'Without this, documents that already exist at the destination are skipped. '
        + 'Locked documents are always skipped.',
      copyConfirm: 'Copy',
      copyRunning: 'Copied {copied}…',
      copyDone: 'Copied {copied}, skipped {skipped}.',
      copyDoneOverwrite: 'Copied {copied}, overwrote {overwritten}, skipped {skipped}.',
    },
    rowMenu: {
      title: 'Actions',
      empty: 'No actions',
      rename: 'Rename',
      duplicate: 'Duplicate',
      duplicateDone: 'Created copy “{name}”.',
      unpack: 'Unpack',
      unpackDone:
        'Extracted {extracted} files to “{folder}” ({skipped} skipped, {failed} failed).',
      delete: 'Delete',
      deleteBody: 'Move “{name}” to the trash? You can restore it later from the trash, or delete it permanently.',
    },
    rename: {
      title: 'Rename',
      label: 'New name',
      confirm: 'Rename',
      invalid: 'Please enter a name without “/”.',
      running: 'Renamed {renamed}…',
      done: 'Renamed {renamed}, skipped {skipped}.',
    },
    archives: {
      heading: 'Versions',
      empty: 'No archived versions yet — they appear after the next edit.',
      createNow: 'Create version now',
      createdOk: 'New version created.',
      createdUnchanged: 'No changes since the last version — nothing to save.',
      createdDisabled: 'Versioning is disabled for this project.',
      restore: 'Restore',
      restoreCopy: 'To new file',
      copiedOk: 'Restored into new file: {path}',
      confirmCopyTitle: 'Restore into a new file?',
      confirmCopyBody:
        'A new document is created next to the current one (name auto-generated, e.g. foo-version-3-<date>.yaml). The current document is not changed and nothing is overwritten.',
      delete: 'Delete',
      cancel: 'Cancel',
      close: 'Close',
      previewTitle: 'Version from {when}',
      previewBinary: 'Preview not available for this file type — please download.',
      compare: 'Compare with current',
      diffTitle: 'Changes since version from {when}',
      diffDescription: 'Archived version (−) against the current document (+).',
      diffDescriptionUnsaved:
        'Archived version (−) against the current document (+), including unsaved edits.',
      diffIdentical: 'No differences.',
      diffShowUnchanged: 'Show {count} unchanged lines',
      diffShowMore: 'Show {count} more lines ({total} not shown)',
      diffTooLarge:
        'Too large to compare here: {lines} lines together, the limit is {max}. Download both versions to compare them.',
      confirmRestoreTitle: 'Restore this version?',
      confirmRestoreBody:
        'The current content is archived as a new version, then this older version becomes the live document. Nothing is lost.',
      confirmDeleteTitle: 'Delete this version permanently?',
      confirmDeleteBody:
        'This archived version is removed for good. The live document is not affected.',
    },
    listEditor: {
      addItem: 'Add item',
      deleteItem: 'Delete item',
      clickToEdit: 'Click to edit',
      emptyItem: '(empty)',
      dragHandle: 'Drag to reorder',
      selectedCountSingular: '{count} selected',
      selectedCountPlural: '{count} selected',
      deleteSelected: 'Delete selected',
      clearSelection: 'Clear selection',
    },
    checklistEditor: {
      clearFilter: 'Clear filter',
      addItem: 'Add item',
      deleteItem: 'Delete item',
      clickToEdit: 'Click to edit',
      emptyItem: '(empty)',
      empty: 'empty',
      dragHandle: 'Drag to reorder',
      selectedCountSingular: '{count} selected',
      selectedCountPlural: '{count} selected',
      deleteSelected: 'Delete selected',
      clearSelection: 'Clear selection',
      togglePriority: 'Toggle priority (none → high → low)',
      openStatusMenu: 'Open status menu',
      totalItems: '{count} items',
      filterActive: 'filter active',
      status: {
        open: 'open',
        done: 'done',
        in_progress: 'in progress',
        review: 'in review',
        blocked: 'blocked',
        needs_info: 'needs info',
        deferred: 'deferred',
        delegated: 'delegated',
        waiting: 'waiting',
      },
    },
    treeEditor: {
      addItem: 'Add item',
      addChild: 'Add child',
      deleteItem: 'Delete item',
      clickToEdit: 'Click to edit',
      emptyItem: '(empty)',
      dragHandle: 'Drag to reorder within the same level',
      expand: 'Expand',
      collapse: 'Collapse',
    },
    mindmapView: {
      panZoomHint: 'Scroll to zoom · Drag to pan · Click a node to fold',
    },
    pdfView: {
      open: 'Open PDF',
    },
    diagramView: {
      renderError: 'Diagram syntax error',
      sourceLabel: 'Source',
      empty: 'No diagram yet — add a Mermaid source in the Raw tab.',
      unsupportedDialect: 'Unsupported diagram dialect: {dialect}. Edit the source in the Raw tab.',
      downloadSvg: 'Download as SVG',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      fitToView: 'Fit to view',
    },
    slidesView: {
      prev: 'Previous slide',
      next: 'Next slide',
      toggleStream: 'Show all slides at once',
      toggleSingle: 'Show one slide at a time',
      modeSingle: 'Single',
      modeStream: 'Stream',
      present: 'Start fullscreen presentation (Space / ← → to navigate, Esc to exit)',
      presentLabel: 'Present',
      exit: 'Exit presentation (Esc)',
      empty: 'No slides yet — add content separated by `---` in the Raw tab.',
    },
    sheetView: {
      addRow: 'Add row',
      addColumn: 'Add column',
      insertRow: 'Insert row below the selection',
      insertRowAbove: 'Insert row above the selection',
      insertColumn: 'Insert column right of the selection',
      insertColumnLeft: 'Insert column left of the selection',
      deleteRow: 'Delete row',
      deleteColumn: 'Delete column',
      recalc: 'Recalculate',
      recalcHint: 'Evaluate all formulas server-side and refresh the results',
      importFile: 'Import from XLSX or CSV (replaces the sheet)',
      exportXlsx: 'Export as XLSX',
      exportCsv: 'Export as CSV',
      columnBorder: 'Column border',
      columnBorderHint: 'Cycle the selected column border: none → right → left → both',
      rowBorder: 'Row border',
      rowBorderHint: 'Cycle the selected row border: none → bottom → top → both',
      cellsSelected: '{n} cells',
      style: 'Style',
      bold: 'Bold',
      italic: 'Italic',
      alignLeft: 'Align left',
      alignCenter: 'Align center',
      alignRight: 'Align right',
      numberFormat: 'Number format',
      fmtGeneral: 'General',
      fmtNumber: 'Number (1,234.56)',
      fmtInteger: 'Integer (1,235)',
      fmtPercent: 'Percent (12%)',
      fmtText: 'Text',
      borders: 'Borders',
      borderTop: 'Top border',
      borderRight: 'Right border',
      borderBottom: 'Bottom border',
      borderLeft: 'Left border',
      borderOuter: 'Outer border around selection',
      borderClear: 'Clear borders',
      hint: 'Click a cell to select · Double-click to edit · Tab/Enter to navigate',
      cellProps: 'Cell properties',
      cellEmptyHint: 'Empty cell — type to add content.',
      colorField: 'Text color',
      backgroundField: 'Background',
      clear: 'Clear',
      clearFormat: 'Clear formatting',
      emptySelectionHint: 'Click a cell to see its properties.',
    },
    graphView: {
      addNode: 'Add node',
      autoLayout: 'Auto-Layout',
      autoLayoutHint: 'Reposition all nodes via dagre hierarchical layout',
      directed: 'Directed',
      hint: 'Drag a node to move · Drag from node edge to connect · Click + Delete to remove',
      nodeProps: 'Node properties',
      edgeProps: 'Edge properties',
      labelField: 'Label',
      colorField: 'Color',
      clearColor: 'Clear',
      deleteNode: 'Delete node',
      deleteEdge: 'Delete edge',
      idEmpty: 'Node id cannot be empty.',
      idDuplicate: 'Another node already has the id "{id}".',
      emptySelectionHint: 'Click a node or edge to edit its properties.',
    },
    workflowView: {
      tabLabel: 'Flow',
      summary: '{states} states · {edges} transitions',
      startsAt: 'Start: {state}',
      startBadge: 'start',
      retryHint: 'This state has a retry block',
      directionVertical: '⇅ Vertical',
      directionHorizontal: '⇄ Horizontal',
      directionHint: 'Switch layout direction',
      undeclared: 'undeclared',
      noType: 'no type',
      start: 'Start',
      starting: 'Starting…',
      startHint: 'Run this workflow now',
      startBlocked: 'Fix the problems listed above first.',
      started: 'Started — run',
      paramRequired: 'Required parameter missing: {keys}',
      problemsTitle: 'This workflow would not start:',
      empty: 'No states — a workflow needs at least one entry under `states:`.',
    },
    researchSourceView: {
      tabLabel: 'Search source',
    },
    mountSourceView: {
      tabLabel: 'Mount',
    },
    modelDocView: {
      tabLabel: 'Model',
    },
    recipeView: {
      tabLabel: 'Recipe',
    },
    chatThemeView: {
      tabLabel: 'Chat theme',
    },
    reportThemeView: {
      tabLabel: 'Report theme',
    },
    promptView: {
      tabLabel: 'Prompt',
    },
    hookView: {
      tabLabel: 'Hook',
    },
    guardView: {
      tabLabel: 'Guard',
    },
    wizardView: {
      tabLabel: 'Wizard',
    },
    providerDocView: {
      tabLabel: 'Provider',
    },
    schedulerView: {
      tabLabel: 'Scheduler',
      parseError: 'This scheduler definition is not valid YAML — fix it in the raw editor.',
    },
    serverToolView: {
      tabLabel: 'Server tool',
      parseError: 'This server tool is not valid YAML — fix it in the raw editor.',
    },
    recordsEditor: {
      addRow: 'Add row',
      deleteItem: 'Delete row',
      clickToEdit: 'Click to edit',
      emptyCell: '—',
      emptyTable: '(empty)',
      dragHandle: 'Drag to reorder · Cmd/Ctrl-Click to multi-select',
      selectedCountSingular: '{count} row selected',
      selectedCountPlural: '{count} rows selected',
      deleteSelected: 'Delete selected',
      clearSelection: 'Clear selection',
      overflowHint: 'Some rows carry more values than the schema declares. They are preserved, but not editable here — switch to the Raw tab to manage them.',
      editSchema: 'Edit schema',
      doneEditingSchema: 'Done editing schema',
      addColumn: 'Add column',
      deleteColumn: 'Delete this column',
      moveColumnLeft: 'Move column left',
      moveColumnRight: 'Move column right',
      schemaEmptyName: 'Column name cannot be empty.',
      schemaDuplicateName: 'Another column is already named "{name}".',
      schemaMinOneColumn: 'A records document needs at least one column.',
    },
    create: {
      newDocument: 'New document',
      fromTemplate: 'Template',
      typeContent: 'Type content',
      uploadFile: 'Upload file',
      templateLoading: 'Loading templates…',
      templateNone: 'No templates available.',
      templateAllTags: 'All tags',
      templateFilter: 'Filter templates…',
      templateBack: 'Templates',
      prefilledFrom: 'Prefilled from: {source}',
      templateNameFixed: 'This template uses a fixed file name.',
      pathLabel: 'Path',
      pathPlaceholder: 'notes/example.md',
      pathHelp: 'Virtual path inside the project. Must be unique.',
      pathPlaceholderUpload: '(defaults to file name)',
      pathHelpUpload: 'Override the destination path inside the project. Optional.',
      nameLabel: 'Name',
      namePlaceholder: 'example.md',
      nameHelp: 'File name in the current folder. Must be unique in the project.',
      namePlaceholderUpload: '(defaults to file name)',
      nameHelpUpload: 'Override the file name. Optional.',
      titleLabel: 'Title',
      titlePlaceholder: 'Optional display title',
      tagsLabel: 'Tags',
      tagsPlaceholder: 'comma, separated, tags',
      tagsHelp: 'Optional, separated by commas.',
      tagsHelpMulti: 'Applied to every uploaded file.',
      typeLabel: 'Type',
      kindLabel: 'Kind',
      kindNone: '(none)',
      kindHelp: 'Optional. Pre-fills a starter body matching the selected kind.',
      kindUnsupported: 'Only available for Markdown, JSON and YAML.',
      contentLabel: 'Content',
      inlineSizeNote:
        'Type the body directly. For file uploads use the upload tab.',
      filesLabel: 'Files',
      filesHelp:
        'Drop one or more files. The server picks compression per file automatically.',
      pathRequired: 'Path is required.',
      nameRequired: 'Name is required.',
      contentRequired: 'Content is required.',
      pickAtLeastOneFile: 'Pick at least one file.',
      multiUploadFailed: '{failed} of {total} files failed. See list below.',
      uploadFailed: 'Upload failed.',
      cancel: 'Cancel',
      submitCreate: 'Create',
      submitUpload: 'Upload',
    },
    preview: {
      binary: 'No inline preview for this file type — use the download button.',
    },
    mime: {
      groupDoc: 'Doc & config',
      groupCode: 'Code',
      groupWeb: 'Web',
      groupOther: 'Other',
    },
  },

  insights: {
    pageTitle: 'Insights',
    zarniwoop: {
      pickProject: 'Pick a project in the sidebar to see its search providers.',
      loading: 'Loading search providers…',
      emptyHeadline: 'No search providers configured',
      emptyBody:
        'No search-source document is configured for this project (or cascaded from _tenant). '
        + 'An operator adds one via the create dialog — a "Search source: …" template per protocol, '
        + 'e.g. "Search source: Serper.dev" — which writes _vance/config/research/<id>.yaml. '
        + 'Just added one? Providers are cached for five minutes; Reload reads them again.',
      reload: 'Reload',
      instances: '{count} instance(s)',
      calls: '{n} call | {n} calls',
      callsBreakdown: '({ok} ok / {errors} error)',
      colEnabled: 'Enabled',
      colInstance: 'Instance',
      colProtocol: 'Protocol',
      colModalities: 'Modalities',
      colAvailability: 'Availability',
      colStatus: 'Status',
      colCalls: 'Calls (ok / err)',
      colLastUsed: 'Last used',
      override: 'override',
      overrideTitle: 'Manual override: {mode}. Configured default (source document): {fallback}.',
      enabled: 'enabled',
      disabled: 'disabled',
      offByDefault: 'off by default',
      offByDefaultTitle: 'The source document has enabled: false',
      reset: 'reset',
      cooldownUntil: 'cooldown until {when}',
      clearCooldown: 'clear cooldown',
      clearCooldownTitle: 'Clear this cooldown — the provider can be queried again immediately',
      lastError: 'last error: {message}',
      footnotePre:
        'Counters and manual overrides are pod-local — both reset when the project is suspended. '
        + 'The configured default (enabled in the source document) lives at',
      footnoteMid: '; the persistent audit log at',
      duration: {
        elapsed: ' (elapsed)',
        minutes: ' (in {n}m)',
        hours: ' (in {n}h)',
        days: ' (in {n}d)',
      },
    },
    toolHealth: {
      scope: 'Scope',
      scopeProject: 'Project',
      scopeTenant: 'Tenant',
      search: 'Search',
      searchPlaceholder: 'subject, signature, note…',
      filter: 'Filter',
      cooldownOnly: 'active cooldown only',
      reload: 'Reload',
      recordCount: '{shown} / {total} records',
      cooldownCount: '{n} active cooldown | {n} active cooldowns',
      pickProject: 'Pick a project in the sidebar to see its tool health.',
      loading: 'Loading tool health…',
      emptyHeadline: 'No health records',
      emptyBodyTenant: 'Nothing has been recorded as degraded or cooling down for this tenant.',
      emptyBodyProject: 'Nothing has been recorded as degraded or cooling down for this project.',
      colSubject: 'Subject',
      colKind: 'Kind',
      colStatus: 'Status',
      colClassification: 'Classification',
      colCooldowns: 'Cooldowns',
      colSince: 'Since',
      colNote: 'Note',
      noMatch: 'No records match the current filters.',
      recovery: 'recovery:',
      recoveryIn: '(in {countdown})',
      noCooldowns: 'No active cooldowns — nothing is gating this subject right now.',
      colSignature: 'Signature',
      colHits: 'Hits',
      colUser: 'User',
      colExpires: 'Expires',
      clear: 'Clear',
      clearTitle: 'Clear this cooldown — the subject can fire again immediately',
      kind: {
        feed: 'feed source',
        search: 'search provider',
        tool: 'tool',
      },
    },
    projectTools: {
      pickProject: 'Pick a project in the sidebar to see its effective tools.',
      loading: 'Loading tools…',
      emptyHeadline: 'No tools',
      emptyBody: 'No built-in, tenant or project tools resolve for this project.',
      search: 'Search',
      searchPlaceholder: 'name, description, type, label…',
      sources: 'Sources',
      sourceProject: 'project',
      sourceVance: '_vance',
      sourceBuiltin: 'built-in',
      filter: 'Filter',
      primaryOnly: 'primary only',
      deferredOnly: 'deferred only',
      showDisabled: 'show disabled',
      colName: 'Name',
      colSource: 'Source',
      colType: 'Type',
      colDescription: 'Description',
      colVisibility: 'Visibility',
      colHealth: 'Health',
      colLabels: 'Labels',
      noMatch: 'No tools match the current filters.',
      hint: 'hint: {text}',
      deferred: 'deferred',
      deferredTitle: 'Hidden from manifest until tool_description activates it',
      primary: 'primary',
      onDemand: 'on demand',
      activeCooldowns: '{count} active cooldown(s)',
      note: 'note:',
      recovery: 'recovery:',
      recoveryIn: '(in {countdown})',
      noCooldowns: 'No active cooldowns.',
      colSignature: 'Signature',
      colClassification: 'Classification',
      colHits: 'Hits',
      colUser: 'User',
      colNote: 'Note',
      colExpires: 'Expires',
      clear: 'Clear',
      clearTitle: 'Clear this cooldown — the tool can fire again immediately',
      disabledByInner: 'Disabled by an inner-layer document',
      countdown: {
        expired: 'expired',
        seconds: '{n}s',
        minutes: '{n}m',
        hours: '{n}h',
        hoursMinutes: '{h}h {m}m',
        days: '{n}d',
        daysHours: '{d}d {h}h',
      },
    },
    recipes: {
      pickProject: 'Pick a project in the sidebar to see its effective recipes.',
      loading: 'Loading recipes…',
      emptyHeadline: 'No recipes available',
      emptyBody: 'No bundled, tenant or project recipes resolve for this project.',
      search: 'Search',
      searchPlaceholder: 'name, description, engine…',
      sources: 'Sources',
      sourceProject: 'project',
      sourceVance: '_vance',
      sourceBundled: 'bundled',
      filter: 'Filter',
      lockedOnly: 'locked only',
      colName: 'Name',
      colSource: 'Source',
      colEngine: 'Engine',
      colDescription: 'Description',
      colParams: 'Params',
      colAllowedTools: 'Allowed-Tools Δ',
      colSkills: 'Skills',
      colProfiles: 'Profiles',
      noMatch: 'No recipes match the current filters.',
      skillsDefault: '{count} default',
      skillsWhitelist: '· whitelist {count}',
    },
    models: {
      pickProject: 'Pick a project in the sidebar to see its models.',
      loading: 'Loading models…',
      reload: 'Reload',
      emptyHeadline: 'No models in the catalog',
      emptyBody: 'Neither the bundled catalog nor any tenant or project layer lists a model for this project.',
      search: 'Search',
      searchPlaceholder: 'instance, model, capability…',
      kind: 'Type',
      groupAll: 'All ({n})',
      groupOption: '{group} ({n})',
      group: {
        llm: 'LLM',
        audio: 'Audio',
        image: 'Image',
        decision: 'Decision',
        other: 'Other',
      },
      sortByName: 'Sort by model name',
      sortByPrice: 'Sort by output price',
      usableOnly: 'Hide chat models the picker does not offer',
      count: '{shown} / {total}',
      projectHeading: 'This project',
      defaultModel: 'Default model',
      defaultModelHint: 'ai.default.provider / ai.default.model',
      defaultMissing: 'not resolvable',
      allowlist: 'Chat allowlist',
      allowlistHint: 'chat.allowed-models — limits what the model picker offers',
      aliasesHeading: 'Aliases',
      aliasesHint: 'ai.alias.* as this project sees them, resolved here.',
      noAliases: 'No alias is set — recipes fall back to the default model.',
      colAlias: 'Alias',
      colTarget: 'Setting',
      colDefinedIn: 'Set in',
      colResolves: 'Resolves to',
      viaTenantDefault: 'via default model',
      modelsHeading: 'Catalog',
      modelsHint: 'Merged model catalog of this project, all modalities. Click a model for its fields and where each one comes from.',
      colModel: 'Model',
      colKind: 'Kind',
      colSize: 'Size',
      colContext: 'Context',
      colPrice: 'Price / 1M tokens',
      colCapabilities: 'Capabilities',
      colOrigin: 'Origin',
      colStatus: 'Status',
      noMatch: 'No models match the current filters.',
      discovered: 'discovered',
      discoveredTitle: 'Contains fields written by model discovery',
      statusUsable: 'usable',
      statusUsableTitle: 'Offered by the model picker in this project',
      statusNoInstance: 'no credentials',
      statusNoInstanceTitle: 'The provider instance has no API key (or, keyless, no base URL) in this project',
      statusNotAllowed: 'not allowed',
      statusNotAllowedTitle: 'Not approved by chat.allowed-models',
      detailTitle: 'Model {spec}',
      detailDescription: 'Merged catalog fields and the layer each one comes from — the innermost layer that sets a field wins.',
      detailLoading: 'Loading fields…',
      detailAliases: 'Aliases pointing here',
      detailFields: 'Model document',
      detailProvider: 'Provider instance ({instance})',
      detailNoProvider: 'No _provider.yaml for this instance.',
      colField: 'Field',
      colValue: 'Value',
      colLayer: 'Layer',
      close: 'Close',
      layer: {
        BUNDLED: 'bundled',
        SYSTEM_AUTO: 'system · discovered',
        SYSTEM: 'system',
        TENANT_AUTO: 'tenant · discovered',
        TENANT: 'tenant',
        PROJECT_AUTO: 'project · discovered',
        PROJECT: 'project',
      },
      definedIn: {
        PROJECT: 'project',
        TENANT: 'tenant',
      },
    },
    rag: {
      noProjectHeadline: 'No project selected',
      noProjectBody: 'Pick a project from the sidebar filter to manage its RAG.',
      disabledPre: 'RAG is disabled for this project —',
      disabledMid: '. Open the',
      llmSettings: 'LLM Settings',
      disabledPost: 'form and pick',
      disabledOr: 'or',
      disabledEnd: 'to enable indexing and search.',
      cardTitle: 'Project RAG — _documents',
      loading: 'Loading…',
      status: 'Status',
      statusDisabled: 'disabled',
      statusActive: 'active',
      statusNotCreated: 'not created',
      effectiveProvider: 'Effective provider',
      pinnedTitle:
        'RAG was created with {created} — tenant now resolves to {effective}. Use Rebuild to migrate.',
      pinnedPre: '(RAG pinned to',
      pinnedPost: ')',
      ragId: 'RAG id',
      embeddingModel: 'Embedding model',
      chunks: 'Chunks',
      created: 'Created',
      autoCreatePre: "The project's default RAG is created automatically the next time the "
        + 'project is brought to RUNNING, or when you press',
      autoCreateReindex: 'Reindex',
      actions: 'Actions',
      actionsHintPre: 'Reindex',
      actionsHintMid: 'queues every active document under',
      actionsHintRebuild: 'Rebuild',
      actionsHintPost:
        'drops the RAG and re-creates it with the current tenant embedding settings; use this '
        + 'after switching providers.',
      actionsHintKeep: 'for re-embedding into the existing RAG — embedding provider and model '
        + 'are kept.',
      working: 'Working…',
      reindex: 'Reindex',
      rebuildButton: 'Rebuild with current embedding model',
      refresh: 'Refresh',
      confirmDropPre: 'This will',
      confirmDropWord: 'drop',
      confirmDropMid: 'the current',
      confirmDropPost:
        'RAG (including all chunks) and re-create it with the tenant\'s current embedding '
        + 'settings. Then every active document will be queued for re-indexing.',
      confirmHint:
        'Confirm only if you switched embedding provider/model and want the new model applied '
        + 'retroactively.',
      confirmYes: 'Yes, rebuild',
      cancel: 'Cancel',
      lastRun: 'Last run:',
      lastRunRebuild: 'rebuild',
      lastRunReindex: 'reindex',
      lastRunQueued: '— {count} document(s) queued.',
      searchTitle: 'Search',
      searchHintPre:
        "Embed the query with the RAG's embedding model and return the top-20 most similar "
        + 'chunks. Useful to inspect what the model would inject as',
      searchHintPost: 'for a given prompt.',
      searchPlaceholder: 'Search the RAG…',
      searching: 'Searching…',
      search: 'Search',
      searchUnavailable: 'Search becomes available once the RAG has been created.',
      noMatches: 'No matches.',
      score: 'score {value}',
    },
    usage: {
      bucket: 'Bucket',
      perDay: 'Per day',
      perWeek: 'Per week',
      perMonth: 'Per month',
      range: 'Range',
      last7: 'Last 7 days',
      last30: 'Last 30 days',
      last90: 'Last 90 days',
      last365: 'Last 365 days',
      emptyHeadline: 'No usage data yet',
      emptyBody:
        'Once an LLM call records its tokens, this view fills in. Models without a pricing block '
        + 'still show their tokens and calls, but their cost reads n/a — add '
        + 'pricing.inputPerMTok / pricing.outputPerMTok to the model YAML to see costs.',
      chartTitle: 'Tokens & Cost over time',
      input: 'Input',
      output: 'Output',
      cacheRead: 'Cached read',
      implicitCacheRead: 'From cache (est.)',
      cacheWrite: 'Cached write',
      cacheWrite1h: 'Cached write (1h TTL)',
      cost: 'Cost',
      coveragePartial:
        'Covers {pct}% of {calls} calls — {unpriced} ran on a model with no price in the catalog '
        + 'and contribute tokens but no amount. Add a',
      coveragePartialPost:
        'block to those model entries (a genuinely free local model declares an explicit zero).',
      coverageAll: 'Covers all {calls} calls in this window.',
      coverageFailed: '{failed} attempts failed; they are counted but not added to the amount.',
      detailHorizon:
        'Totals reach back further than the drill-down: per-call detail exists from {from} '
        + 'onwards, before that only daily sums.',
      topProjects: 'Top projects',
      project: 'Project',
      noProjectData: 'No project data in this window.',
      topModels: 'Top models',
      model: 'Model',
      noModelData: 'No model data in this window.',
      byCaller: 'By caller',
      callerHint:
        'Who is spending. Autonomous work shows up here even when nobody is watching a chat. '
        + 'Think-engines appear under their own name; the rest name themselves —',
      callerHintLight: 'for single-shot helper calls (discovery, follow-up, title generation),',
      callerHintCompaction: 'for memory upkeep,',
      callerHintImages: 'for images,',
      callerHintEmbeddings: 'for embeddings.',
      caller: 'Caller',
      noCallerData: 'No caller data in this window.',
      byRecipe: 'By recipe',
      recipe: 'Recipe',
      noRecipeData: 'No recipe data in this window.',
      seriesTokens: 'Tokens (in+out)',
      seriesCacheRead: 'Cache read',
      seriesCost: 'Cost ({currency})',
      axisCost: 'Cost',
      axisTokens: 'Tokens',
      budgetTitle: 'Cost budget',
      budgetTenant: 'Tenant',
      budgetProject: 'Project {project}',
      budgetDaily: 'Today',
      budgetMonthly: 'This month',
      budgetTotal: 'Since {from}',
      budgetValue: '{used} of {limit} ({pct}%)',
      budgetExhausted: 'Exhausted',
      budgetWarning: 'Warning',
      budgetNone: 'No budget set',
      budgetNoneHint: 'Unlimited. Set one in the settings form "LLM Cost Budget".',
      budgetUnpriced: '{calls} calls on unpriced models not included',
      budgetUncounted: '{amount} in another currency not included',
      budgetTotalIncomplete:
        'An absolute budget is set without a start date — it is not enforced until one is set.',
    },
    toolUsage: {
      pickProject: 'Pick a project in the sidebar to see its measured tool demand.',
      loading: 'Loading tool usage…',
      emptyHeadline: 'No tool usage recorded yet',
      emptyBody:
        'Counters fill up as agents call tools in this project. They are also empty right after '
        + 'a reset.',
      reload: 'Reload',
      roleCount: '{n} role | {n} roles',
      toolCount: '{n} tool | {n} tools',
      callCount: '{n} call | {n} calls',
      discoveryCount: '{n} discovery lookup | {n} discovery lookups',
      filterPlaceholder: 'Filter tool or family…',
      explainPre: 'Demand = calls + discovery lookups, counted per role. The tool-surface budget '
        + 'uses these numbers to order tools',
      explainInside: 'inside',
      explainPost: "a priority class when an endpoint's tool limit forces a cut — it never "
        + 'promotes a tool across classes. Discovery lookups are counted separately because '
        + 'they measure demand before the deferral hurdle.',
      noMatch: 'No tool matches “{filter}”.',
      discovery: '{n} discovery',
      lastActivity: 'last activity {when}',
      colTool: 'Tool',
      colFamily: 'Family',
      colCalls: 'Calls',
      colDiscovery: 'Discovery',
      colDemand: 'Demand',
      colLastUsed: 'Last used',
    },
    usageTable: {
      calls: 'Calls',
      tokensIn: 'Tokens in',
      cacheRead: 'Cache read',
      implicitCacheRead: 'Cache read (est.)',
      cacheWrite: 'Cache write',
      cacheWrite1h: 'Cache write (1h TTL)',
      tokensOut: 'Tokens out',
      cost: 'Cost',
    },
    clientTools: {
    showInventory: 'Show this app\'s tool inventory',
    inventoryHint: 'The connector\'s own declaration — agent tools and MCP packs, no session needed.',
    inventoryEmpty: 'The app has nothing to offer — enable the agent tools for this account.',
    packFailed: 'Pack "{pack}" failed to start:',
    loading: 'Loading client tools…',
  },
  liveTools: {
      pickSession: 'Select a session to inspect its live client tools.',
      loading: 'Loading client tools…',
      bound: 'bound',
      notBound: 'not bound',
      editor: 'editor: {id}',
      noConnection: 'no active connection',
      emptyHeadlineBound: 'No client tools',
      emptyHeadlineUnbound: 'Client not connected',
      emptyBodyBound: 'The client is connected but did not register any tools.',
      emptyBodyUnbound:
        'Live tools appear when the client opens its WebSocket and pushes its tool list.',
      colName: 'Name',
      colPrimary: 'Primary',
      colDescription: 'Description',
      colParams: 'Params',
      primary: 'primary',
      secondary: 'secondary',
    },
    megadodo: {
      searchPlaceholder: 'Search message…',
      refresh: 'Refresh',
      failed: '{n} failed',
      running: '{n} running',
      operations: '{n} operation | {n} operations',
      pickProject: 'Pick a project to see its activity.',
      loading: 'Loading…',
      emptyFailed: 'Nothing failed in the retained window.',
      emptyAll: 'No activity recorded yet.',
    },
    tabs2: {
      more: 'More',
      liveTools: 'Live Tools',
    },
    prakMeta: {
      importance: 'importance:',
      confidence: 'confidence:',
      decay: 'decay:',
    },
    executions: {
      pickProject: 'Pick a project in the sidebar to see its executions.',
      search: 'Search',
      searchPlaceholder: 'command, id, owner, session…',
      filter: 'Filter',
      onlyRunning: 'running only',
      refresh: 'Refresh',
      loading: 'Loading executions…',
      emptyHeadline: 'No executions',
      emptyBody:
        'No shell jobs are tracked for this project yet. Start one via exec_run / client_exec_run.',
      colId: 'Id',
      colOwner: 'Owner',
      colStatus: 'Status',
      colCommand: 'Command',
      colStarted: 'Started',
      colLastOutput: 'Last output',
      colExit: 'Exit',
      noMatch: 'No executions match the current search.',
      fieldId: 'id:',
      fieldSession: 'session:',
      fieldProcess: 'process:',
      fieldRootDir: 'rootDir:',
      fieldEnded: 'ended:',
      last: 'last',
      lines: 'lines',
      refreshTail: 'Refresh tail',
      loadingStream: 'Loading {stream}…',
      emptyStream: '(empty)',
    },
    power: {
      refresh: 'Refresh',
      loading: 'Loading LLM power state…',
      hint: 'Switching off stops every model call: chat, embeddings, images, audio, decisions — free local models included.',
      tenantOn: 'LLM access is on',
      tenantOff: 'LLM access is off',
      tenantOnBody: 'Model calls of this tenant are allowed, unless a user below is switched off.',
      tenantOffBody: 'No model call of this tenant goes out. Calls already running finish.',
      switchOn: 'Switch LLM access on',
      switchOff: 'Switch LLM access off',
      switchUserOn: 'Switch LLM access on for {user}',
      switchUserOff: 'Switch LLM access off for {user}',
      confirmOff: 'Switch off LLM access for the whole tenant? Every chat, agent and background job that needs a model stops working until it is switched back on.',
      offSince: 'Off since {when}',
      offSinceBy: 'Off since {when} — {note}',
      pending: 'Applying on all brain pods — confirmed at the next full minute…',
      unconfirmed: 'Not confirmed by the brain yet — refresh to check again.',
      usersHeading: 'Users',
      usersNote: 'A switched-off user cannot call a model, in any project. Background jobs without a user are only stopped by the main switch.',
      usersNoteTenantOff: 'The main switch is off: no user can call a model, whatever their own switch says.',
      searchPlaceholder: 'Search users',
      onlyOff: 'Only switched off ({n})',
      noUsers: 'No matching users',
      serviceAccount: 'Service account',
      unknownUser: 'User no longer exists',
      on: 'On',
      off: 'Off',
    },
    quotas: {
      refresh: 'Refresh',
      hint: 'Tenant-wide quota + usage. Documents shows storage; LLM shows the cost budget and the actual spend.',
      documentsHeading: 'Documents',
      storageTitle: 'Storage quota',
      storageRow: 'Tenant storage',
      storagePercent: '{percent}% used',
      storageFree: '{bytes} free',
      storageUnlimited: 'Unlimited',
      storageUnlimitedHint: 'No storage.quota.maxBytes is set on the _tenant project.',
      storageUnknown: 'Quota state not yet available.',
      storageExhausted: 'Exhausted',
      storageWarning: 'Warning',
      projectsHeading: 'Projects',
      projectsTitle: 'Active projects',
      projectsRow: 'Active projects',
      projectsHint:
        'Projects that are not archived, suspended ones included. Creating, copying and unarchiving a project is refused at the limit.',
      projectsUnlimitedHint: 'No limit. Set one in the settings form "Project Quota" on the tenant.',
      projectsValue: '{active} of {limit}',
      projectsValueUnlimited: '{active} (unlimited)',
      projectsFull: 'Limit reached — new projects are refused',
      usersHeading: 'Users',
      usersTitle: 'Accounts and teams',
      seatsRow: 'Seats (people)',
      seatsHint:
        'Accounts of people that are not disabled, pending and SSO-prepared ones included. Creating a user and enabling a disabled one is refused at the limit.',
      seatsFull: 'Limit reached — new users are refused',
      serviceAccountsRow: 'Service accounts',
      serviceAccountsHint:
        'Service accounts that are not disabled, the ones Trillian creates included. Internal _vance-* accounts do not count. A new Trillian does not start its working side at the limit.',
      serviceAccountsFull: 'Limit reached — new service accounts are refused',
      usersUnlimitedHint: 'No limit. Set one in the settings form "User Quota" on the tenant.',
      teamsRow: 'Teams',
      teamsHint: 'Teams that are not disabled. Creating a team and enabling a disabled one is refused at the limit.',
      teamsUnlimitedHint: 'No limit. Set one in the settings form "Team Quota" on the tenant.',
      teamsFull: 'Limit reached — new teams are refused',
      llmHeading: 'LLM',
      powerTitle: 'LLM access',
      powerRow: 'Tenant LLM switch',
      powerOn: 'On',
      powerOff: 'Off',
      powerOnBody: 'Model calls are allowed, unless a per-user switch is off. Set in the Power tab.',
      powerOffBody: 'No model call of this tenant goes out. Calls already running finish.',
      unknown: '—',
      budgetTitle: 'Cost budget',
      budgetHint: 'Daily, monthly and (when set) since the start date. Each row is one window of one level.',
      budgetTenant: 'Tenant',
      budgetProject: 'Project {project}',
      budgetNone: 'No budget set',
      budgetNoneHint: 'Unlimited. Set one in the settings form "LLM Cost Budget".',
      budgetExhausted: 'Exhausted',
      budgetWarning: 'Warning',
      budgetTotalIncomplete:
        'An absolute budget is set without a start date — it is not enforced until one is set.',
      windowDaily: 'Today',
      windowMonthly: 'This month',
      windowTotal: 'Since {from}',
      windowValue: '{used} of {limit} ({pct}%)',
      unpricedCalls: '{calls} unpriced',
      uncounted: '{amount} uncounted',
      adminOnly:
        'Tenant admin role required for the budget breakdown and per-project usage. Everything else still loads.',
      projectHeading: 'Per-project LLM usage',
      projectCardTitle: 'Per-project breakdown',
      projectEmptyHeadline: 'No project usage in this window',
      projectEmptyBody:
        'Once an LLM call is attributed to a project, this view fills in. Buckets group by project and currency.',
      totalCalls: 'Calls',
      totalCost: 'Cost',
      coverageLabel: 'Coverage',
      coveragePartial: '{pct}% priced · {unpriced} unpriced',
      colProject: 'Project',
      colCalls: 'Calls',
      colTokensIn: 'Tokens in',
      colTokensOut: 'Tokens out',
      colCost: 'Cost',
      failedSuffix: '{n} failed',
      windowLabel: 'Window: last {days} day(s)',
      scopeTenantHint: 'Scope: whole tenant — change in the sidebar to limit to one project.',
      scopeProject: 'Scope: project {project} — change in the sidebar.',
      storageLive: 'Live (working set)',
      storageTrash: 'Trash',
      storageTrashHint: '{count} document(s) in _vance/trash/',
      storageArchives: 'Archive versions',
      storageArchivesHint: '{count} archive entry/entries',
      reclaimableHint: 'Reclaimable by cleanup: {bytes}',
      refreshBreakdown: 'Refresh breakdown',
      emptyTrash: 'Empty trash',
      emptyTrashConfirm:
        'Permanently delete {count} document(s) in the trash of this scope ({bytes})? The bytes are released immediately and the action cannot be undone.',
      emptyTrashConfirmLabel: 'Empty trash',
      thinArchives: 'Thin archives…',
      cleanupActionTrash: 'trash',
      cleanupActionArchives: 'archives',
      cleanupDone: 'Cleanup done — {action} released {bytes}.',
    },
    cleanup: {
      dialog: {
        title: 'Thin archive versions',
        description:
          'Keep the newest N versions of every document in this scope; delete the rest. Versions are sorted by archivedAt, newest first. Set N to 0 to delete every archive entry.',
        keepLabel: 'Versions to keep per document',
        keepHint: 'Range: {min}–{max}; server clamps anything outside.',
        previewScope: 'Scope',
        scopeTenant: 'Whole tenant',
        previewArchives: 'Archive entries',
        previewDelete: 'Estimated to delete',
        previewHint:
          'The exact number depends on how many versions each document has — this is a projection. The server returns the real count in its response.',
        dangerBadge: 'all',
        confirmKeep: 'Thin archives',
        confirmZero: 'Delete every archive',
        zeroWarning:
          'Set "Versions to keep per document" to 0. Every archive entry in this scope will be permanently deleted; only the current live versions remain. The bytes are released immediately; the action cannot be undone.',
        submitting: 'Running…',
        errorGeneric: 'Archive cleanup failed.',
      },
    },
    leases: {
      refresh: 'Refresh',
      loading: 'Loading leases…',
      holderCount: '{n} lease held | {n} leases held',
      deadPodCount: '{n} on a dead pod | {n} on dead pods',
      emptyHeadline: 'No leases',
      emptyBody: 'Nothing in this tenant holds a resource lease right now.',
      countersHeading: 'Occupancy',
      countersHint: 'Slots in use per funnel level of this tenant. The global level spans all tenants and is not shown.',
      noCounters: 'No counters.',
      holdersHeading: 'Held leases',
      noHolders: 'No leases held.',
      colResource: 'Resource',
      colLevel: 'Level',
      colScope: 'Scope',
      colInUse: 'In use',
      colUpdated: 'Updated',
      colType: 'Type',
      colHolder: 'Holder',
      colProjectUser: 'Project / user',
      colPod: 'Pod',
      colHeld: 'Held',
      colLastSeen: 'Last used',
      level: {
        tenant: 'tenant',
        project: 'project',
        user: 'user',
      },
      drift: 'drift',
      driftTitle: 'Only {booked} held leases book this counter — the next reconcile corrects it.',
      pendingTitle: 'Still acquiring its levels.',
      tokenTitle: 'Holder token',
      podDead: 'dead pod',
      podDeadTitle: 'The holder pod is gone — the reaper frees this lease at its next round.',
      podBound: 'pod-bound',
      podBoundTitle: 'The resource lives in the holder pod and dies with it.',
      ttl: 'TTL {n}s',
      revoke: 'Revoke',
      confirmRevoke: 'Revoke the {type} lease on "{resource}" ({ref})? The slot is freed and the resource is cleaned up — a running job or session using it is stopped.',
      age: {
        seconds: '{n}s ago',
        minutes: '{n}m ago',
        hours: '{n}h ago',
        days: '{n}d ago',
      },
    },
    addons: {
      refresh: 'Refresh',
      count: '{n} addon | {n} addons',
      loaded: '{n} loaded',
      disabled: '{n} disabled',
      broken: '{n} broken',
      loading: 'Loading addons…',
      emptyHeadline: 'No addons',
      emptyBody:
        'The addons collection is empty — no first-party addons bundled, none installed via vance-anus.',
      colAddon: 'Addon',
      colStatus: 'Status',
      colSource: 'Source',
      colVersion: 'Version',
      colNotes: 'Notes',
      colUnpacked: 'Unpacked',
      colChecksum: 'Checksum',
      footnotePre: 'Read-only view. Use',
      footnotePost: 'for changes.',
      status: {
        disabled: 'disabled',
        disabledTitle: 'enabled=false in db.addons',
        loaded: 'loaded',
        loadedTitle: 'unpacked + Spring bean active',
        broken: 'broken',
        brokenTitle: 'unpacked but Spring did not register the VanceAddon bean',
        builtin: 'built-in',
        builtinTitle: 'addon ships inside the brain image (no separate .vab bundle)',
        missing: 'missing',
        missingTitle: 'no on-disk bundle and no Spring bean',
      },
      checksum: {
        verified: 'verified',
        verifiedTitle: 'on-disk .vab hash matches the configured checksum',
        mismatch: 'mismatch',
        mismatchTitle:
          'on-disk .vab hash does NOT match — entrypoint should have refused this addon',
        unverified: 'unverified',
        unverifiedTitle: 'checksum set but no source .vab cached to verify against',
      },
      source: {
        bundled: 'bundled',
        builtin: 'built-in',
        url: 'url',
      },
    },
    control: {
      stop: 'Stop',
      forceStop: 'Force stop',
      stopAll: 'Stop all',
      forceStopAll: 'Force stop all',
      stopTooltip: 'Graceful stop: engine.stop on the process lane, CLOSED with reason STOPPED.',
      forceStopTooltip:
        'Force stop a wedged process: halt flag + immediate CLOSED (reason FORCE) — waits for nothing.',
      stopAllTooltip: 'Stop every process of this session, chat-process included.',
      forceStopAllTooltip: 'Force-stop every process of this session — the cut.',
    },
    trillian: {
      refresh: 'Refresh',
      count: '{n} Trillian | {n} Trillians',
      loading: 'Loading…',
      emptyHeadline: 'No Trillians',
      emptyBody:
        'No Trillian control session in this tenant yet — start one from a chat with a trillian recipe.',
      loopsOn: 'loops allowed',
      loopsOff: 'loops blocked',
      pause: 'Pause',
      resume: 'Continue',
      control: 'Control',
      worker: 'User-Loop',
      session: 'Session',
      user: 'User',
      project: 'Project',
      nature: 'Nature',
      created: 'Created',
      account: 'Account',
      inbox: 'Inbox',
      lastRun: 'Last run',
      attributes: 'Attributes',
      noWorker:
        'No user-loop built — the control chat works, the working side is suppressed.',
      taskWorkers: 'Task workers',
      pending: 'Pending',
    },
    cluster: {
      refresh: 'Refresh',
      podCount: '{n} pod | {n} pods',
      projectCount: '{n} project (this tenant) | {n} projects (this tenant)',
      master: 'Cluster master',
      lease: 'lease {remaining}',
      noMaster: 'no master elected',
      loading: 'Loading cluster…',
      emptyHeadline: 'No pods',
      emptyBody: 'No brain pods are registered in this cluster.',
      colNode: 'Node',
      colStatus: 'Status',
      colEndpoint: 'Endpoint',
      colHeartbeat: 'Heartbeat',
      colBooted: 'Booted',
      colVersion: 'Version',
      colPlacement: 'Placement',
      colPlacementTitle: "What a project's placementSelector is matched against",
      colProjects: 'Projects (this tenant)',
      masterBadge: 'master',
      masterBadgeTitle: 'Currently holds the cluster-master lease',
      selfBadge: 'self',
      selfBadgeTitle: 'This is the brain currently serving the request',
      cordoned: 'cordoned',
      cordonedTitle: 'Exclusive with no labels — nothing matches this pod at all.',
      exclusive: 'exclusive',
      exclusiveTitle: 'A project without a placement selector is not eligible here.',
      any: 'any',
      anyTitle: 'No labels and not exclusive — accepts any project.',
      loadScore: 'score {current} / {max}',
      noCap: 'no cap published',
      pctOfCap: '{pct}% of cap',
      loadHint: 'Sum over all tenants — the number placement actually compares against.',
      age: {
        seconds: '{n}s ago',
        minutes: '{n}m ago',
        hours: '{n}h ago',
        days: '{n}d ago',
      },
      remaining: {
        expired: 'expired',
        seconds: 'in {n}s',
        minutes: 'in {n}m',
        hours: 'in {n}h',
        days: 'in {n}d',
      },
    },
    loading: 'Loading…',
    filters: {
      project: 'Project',
      user: 'User',
      userPlaceholder: '(optional)',
      status: 'Status',
      allProjects: '(all projects)',
      all: '(all)',
      live: '(live)',
      running: '(running)',
      closed: 'closed',
    },
    sidebar: {
      loadingSessions: 'Loading sessions…',
      noSessionsHeadline: 'No sessions',
      noSessionsBody: 'No sessions match the current filter.',
      loadMore: 'Load more',
    },
    emptyMain: {
      headline: 'Select something',
      body:
        'Pick a session on the left to inspect, or expand to drill into its processes.',
    },
    tabs: {
      overview: 'Overview',
      processes: 'Processes ({count})',
      timeline: 'Timeline',
      chat: 'Chat',
      memory: 'Memory',
      tree: 'Tree',
      llmTrace: 'LLM Trace',
      cacheStats: 'Cache',
      prakRuns: 'Prak',
    },
    session: {
      headerLabel: 'Session',
      detailsTitle: 'Details',
      mongoId: 'Mongo id',
      user: 'User',
      project: 'Project',
      status: 'Status',
      client: 'Client',
      boundConn: 'Bound conn',
      chatProcess: 'Chat process',
      created: 'Created',
      lastActivity: 'Last activity',
      lastLabel: 'last',
      processesTitle: 'Processes in this session',
      noProcesses: 'No processes yet.',
      exportButton: 'Export',
      exportTooltip: 'Download a JSON-lines bundle of this session for external diagnostics',
      exportFailed: 'Export failed.',
      sharedOn: 'Shared',
      sharedOff: 'Not shared',
      sharedOnTooltip:
        'Session is shared — every connection in the tenant may join. Click to make it private again.',
      sharedOffTooltip:
        'Session is private. Click to share it — every connection in the tenant may join.',
    },
    process: {
      headerLabel: 'Process',
      sessionLinkTooltip: 'Back to the session view',
      titlePrefix: 'Process {name}',
      mongoId: 'Mongo id',
      session: 'Session',
      engine: 'Engine',
      recipe: 'Recipe',
      status: 'Status',
      parent: 'Parent',
      goal: 'Goal',
      created: 'Created',
      updated: 'Updated',
      engineParams: 'Engine params',
      activeSkills: 'Active skills',
      noneActive: 'None active.',
      fromRecipe: 'recipe',
      oneShot: 'one-shot',
      pendingQueue: 'Pending queue',
      drained: 'Drained.',
      chatLoading: 'Loading chat…',
      chatEmptyHeadline: 'No messages',
      chatEmptyBody: 'This process has no chat history.',
      archivedToMemory: 'Memory: {id}',
      memoryLoading: 'Loading memory…',
      memoryEmptyHeadline: 'No memory',
      memoryEmptyBody: 'No engine-side memory entries are scoped to this process.',
      supersededBy: 'superseded by {id}',
      sources: 'sources: {count}',
      metadata: 'metadata',
      treeLoading: 'Loading tree…',
      treeEmptyHeadline: 'Empty tree',
      treeEmptyBody: 'No nodes have been planned yet.',
      marvinTreeTitle: 'Marvin tree',
      prakOnlyToggle: 'Prak-generated only',
      prakBadge: 'Prak',
      prakRunsLoading: 'Loading Prak runs…',
      prakRunsEmptyHeadline: 'No Prak runs',
      prakRunsEmptyBody:
        'This process has no PrakRunRecord rows yet. Enable vance.prak.sideChannelEnabled and trigger a compaction.',
      prakRunDuration: '{ms} ms',
      prakRunSpan: 'span: {count} messages',
      prakRunSanitize: 'Sanitize',
      prakRunStrength: 'Strength',
      prakRunPromotion: 'Promotion',
      prakRunRaw: 'raw',
      prakRunFinal: 'final',
      prakRunDropped: 'dropped',
      prakRunDedup: 'dedup',
      prakRunHardCap: 'hard-cap',
      prakRunCoverage: 'coverage',
      prakRunOverrides: 'overrides',
      prakRunTagsModified: 'tags written',
      prakRunPromoted: 'promoted',
      prakRunInboxOffered: 'inbox-offered',
      prakRunSkipped: 'skipped',
      prakRunRefreshed: 'refreshed',
      prakRunAffectsDeferred: 'affects deferred',
      prakRunPersistedMemories: 'persisted memory ids',
    },
    help: {
      title: 'About this view',
      loading: 'Loading…',
      unavailable: 'Help unavailable: {error}',
      empty: 'No help content.',
    },
    workflows: {
      pickProject: 'Pick a project on the left to list its workflows.',
      loading: 'Loading workflows…',
      emptyHeadline: 'No workflows',
      emptyBody:
        'This project has no workflow YAMLs under _vance/workflows/. Author one with the workflow-author skill, then refresh.',
      selectHeadline: 'Pick a workflow',
      selectBody: 'Select a workflow on the left to view its definition and runs.',
      summaryLine: '{params} params · {states} states',
      definitionTab: 'Definition',
      runsTab: 'Runs ({total})',
      runsTabWithRunning: 'Runs ({total}, {running} running)',
      triggerGenericError: 'Trigger failed.',
      paramRequired: 'Parameter "{key}" is required.',
      paramNotInteger: 'Parameter "{key}" must be an integer (got "{raw}").',
      paramNotJson: 'Parameter "{key}" is not valid JSON: {error}',
      detail: {
        start: 'Start state',
        version: 'Version',
        source: 'Source',
        description: 'Description',
        allowedTools: 'Allowed tools',
        rawYaml: 'raw YAML',
      },
      trigger: {
        title: 'Trigger',
        help:
          'Starts a fresh workflow run. Fill in the parameters (required ones marked *), then trigger. The run executes asynchronously on the project lane.',
        noParams: 'This workflow declares no parameters.',
        button: 'Trigger workflow',
        spawnedPrefix: 'Spawned workflow:',
        runIdLabel: 'workflowRunId:',
      },
      runs: {
        openInRunView: 'Open in run view',
        title: 'Runs',
        subtitle: '{total} most recent runs (newest first, max 100)',
        refresh: 'Refresh',
        emptyHeadline: 'No runs yet',
        emptyBody: 'This workflow has never been started in this project.',
        state: 'state',
        startedBy: 'by',
        startedAt: 'at',
      },
    },
    events: {
      bearerBadge: '· 🔒 bearer',
      disabledBadge: '· disabled',
      pickProject: 'Pick a project on the left to list its events.',
      loading: 'Loading events…',
      emptyHeadline: 'No events',
      emptyBody:
        'This project has no event YAMLs under _vance/events/. Author one with the event-author skill, then refresh.',
      selectHeadline: 'Pick an event',
      selectBody: 'Select an event on the left to view its details and trigger it.',
      disabledHint: 'Event is disabled — flip enabled: true in the YAML to trigger.',
      payloadJsonError: 'Payload is not valid JSON: {error}',
      triggerGenericError: 'Trigger failed.',
      detail: {
        workflow: 'Workflow',
        enabled: 'Enabled',
        methods: 'Methods',
        auth: 'Auth',
        runAs: 'runAs',
        source: 'Source',
        description: 'Description',
        bearerConfigured: 'bearer token configured',
        bearerNone: 'no auth (public)',
        staticParams: 'static params',
        rawYaml: 'raw YAML',
      },
      trigger: {
        title: 'Trigger',
        help:
          'Fires the event as an admin (JWT-authenticated). The event’s bearer token is not required here. Optional JSON payload is forwarded to the workflow under params.payload.',
        payloadLabel: 'Payload (JSON, optional)',
        // Curly braces are escaped via vue-i18n's literal syntax — bare
        // {…} would be parsed as a placeholder and crash the compiler.
        payloadPlaceholder: "{'{'}\n  \"ref\": \"main\"\n{'}'}",
        button: 'Trigger event',
        spawnedPrefix: 'Spawned workflow:',
        runIdLabel: 'workflowRunId:',
      },
    },
    llmTrace: {
      loading: 'Loading LLM traces…',
      emptyHeadline: 'No LLM traces',
      emptyBody:
        'Either tracing.llm was off when this process ran, or all rows have aged out (90-day TTL).',
      orphan: '(orphan)',
      toolCall: 'tool-call: {name}',
      toolResult: 'tool-result: {name}',
      idLabel: 'id={id}',
      seqLabel: 'seq {seq}',
      emptyLeg: '(empty)',
      legCount: '{count} legs',
      toolCallSingular: '· {count} tool-call',
      toolCallPlural: '· {count} tool-calls',
      tokensInOut: '{tokensIn} in / {tokensOut} out',
      toolsSurface: '· {count} tools ({kb})',
    },
    cacheStats: {
      loading: 'Loading cache stats…',
      emptyHeadline: 'No cache data',
      emptyBody:
        'Either tracing.llm was off for this process, the prompt was below the cacheable minimum of the model, '
        + 'or the provider reported no cache tokens. Cache hits are measured per provider: Anthropic reports '
        + 'them natively, OpenAI and Gemini when their gateway exposes cached tokens.',
      headlineTitle: 'Cache hit rate',
      headlineSub: 'across {rounds} LLM calls',
      headlineHint:
        'Share of input tokens served from the prompt cache — higher is better. Spec target: ≥ 70%.',
      headlineEstimate: '≈ {pct} including estimated cache reads',
      breakdownTitle: 'Token breakdown',
      cacheRead: 'Read from cache',
      cacheCreate: 'Written to cache',
      implicitCacheRead: 'From cache (estimated)',
      uncachedInput: 'Uncached input',
      totalInput: 'Total input',
      outputTokens: 'Output',
      tokensSaved: 'Tokens saved',
      savingsHint:
        'Cache-read tokens cost ~10% of the normal input price; the savings estimate ignores the one-off '
        + 'write surcharge on creation tokens. Estimated reads are labeled — the provider billed only the '
        + 'uncached tail, so they carry no cost.',
      providersTitle: 'Per provider',
      colProvider: 'Provider : model',
      colRounds: 'Calls',
      colHitRate: 'Hit rate',
      unknownProvider: 'unknown — row predates provider tracking',
      minCacheableHint: 'Prompts below {tokens} tokens are too small to cache for this model.',
      reload: 'Reload',
    },
    timeline: {
      loading: 'Loading timeline…',
      noProcessesHeadline: 'No processes yet',
      noProcessesBody: 'This session has no think-processes — nothing to time-line.',
      failedToLoad: 'Failed to load timeline data.',
      eventSpawn: 'Process spawned · engine {engine}',
      eventChat: '{role}: {preview}',
      eventMemory: 'memory · {kind}',
      eventMemoryWithTitle: 'memory · {kind} · {title}',
      eventMarvinNode: 'node · {taskKind} · {goal}',
      eventPending: 'pending · {type}',
      noGoal: '(no goal)',
      tagRecipe: 'recipe {name}',
      tagArchived: 'archived',
      tagSuperseded: 'superseded',
      tagQueued: 'queued',
    },
    processTree: {
      openInView: 'Open in process view',
      eventCountSingular: '{count} event',
      eventCountPlural: '{count} events',
    },
    marvin: {
      noGoal: '(no goal)',
      toWorker: '→ worker',
      failure: 'failure: {reason}',
    },
  },

  tools: {
    detail: {
      tenantNote:
        'You are editing the _tenant system project — changes here are tenant-wide defaults. User projects shadow individual tools by re-creating them with the same name.',
      draftHint:
        'This document lies outside _vance/server-tools/ — the tool loader only reads that folder, so the tool is not active.',
    },
    cards: {
      identityTitle: 'Identity',
      parametersTitle: 'Parameters (JSON)',
      parametersHelp:
        "Type-specific configuration. The type's parameter schema is shown below the editor.",
      labelsTitle: 'Labels',
      packTitle: 'Pack',
      packHelp:
        'Multi-tool packs (REST API, MCP server) expand into many sub-tools. The fields below configure pack-wide defaults; singleton packs (e.g. doc_lookup) ignore them.',
      typeSchemaTitle: 'Parameter schema of this type',
    },
    fields: {
      type: 'Type',
      description: 'Description',
      descriptionHelp: 'Shown to the LLM. One short paragraph, plain text.',
      enabled: 'Enabled',
      primary: 'Primary (advertised on every turn)',
      defaultDeferred: 'Default to deferred',
      defaultDeferredHelp:
        'Pack-wide default for Tool.deferred(). When true, sub-tools surface only via the discovery block until the LLM activates them with tool_description — recommended for packs with many endpoints.',
      disabledSubTools: 'Disabled sub-tools',
      disabledSubToolsHelp:
        'One sub-tool name per line. Local names only (without the <pack>__ prefix). Empty means all sub-tools active.',
      labels: 'Labels',
      labelsHelp:
        'One per line (or comma-separated). Recipes can target labels via {\'@\'}<label>.',
      promptHint: 'Prompt hint',
      promptHintHelp:
        'Optional. Added to the system prompt on turns where this tool is reachable — when and how the model should use it.',
    },
    errors: {
      parametersMustBeObject: 'Parameters must be a JSON object.',
      parametersInvalidJson: 'Parameters: invalid JSON — {message}',
      loadTypesFailed: 'Could not load the tool types.',
      testFailed: 'The connection test failed.',
      loginFailed: 'The login could not be started.',
      logoutFailed: 'The logout failed.',
    },
    mcp: {
      serverTitle: 'MCP server',
      serverHelp: 'Connection and authentication. Switch to JSON for settings the form does not show.',
      modeLabel: 'Editor',
      modeForm: 'Form',
      modeJson: 'JSON',
      connection: 'Connection',
      transport: 'Transport',
      transportHttp: 'HTTP',
      transportStdio: 'Local process',
      url: 'Server URL',
      urlHelp: 'Streamable-HTTP endpoint, e.g. https://mcp.example.com/mcp.',
      command: 'Command',
      commandHelp: 'One argument per line, e.g. npx, -y, {\'@\'}modelcontextprotocol/server-filesystem, /data.',
      cwd: 'Working directory',
      env: 'Environment',
      mapHelp: 'One KEY=value per line.',
      authentication: 'Authentication',
      authType: 'Authentication',
      authNone: 'None',
      authOauth: 'OAuth login',
      authBearer: 'Bearer token',
      authApiKey: 'API key header',
      authBasic: 'User and password',
      oauthHelp:
        'The server is logged in with the "Log in" button. Vancetope finds the login server and registers itself — fill in a client ID only for servers that do not allow that.',
      loginScope: 'Whose account',
      loginScopeHelp:
        'Personal: every user logs in with their own account. Project or tenant: one account an admin logs in, used by everybody.',
      loginScopeUser: 'Personal (each user)',
      loginScopeProject: 'One per project',
      loginScopeTenant: 'One for the tenant',
      loginScopeShort: {
        user: 'personal login',
        project: 'project account',
        tenant: 'tenant account',
      },
      scopes: 'Scopes',
      scopesHelp: 'Space-separated. Empty: the scopes the server asks for.',
      clientId: 'Client ID',
      clientIdHelp: 'Optional — only for servers without self-registration.',
      clientSecret: 'Client secret',
      secretHelp: 'Better as a reference, e.g. {\'{{\'}secret:tenant:my.key{\'}}\'}, with the value stored as a setting.',
      token: 'Token',
      headerName: 'Header',
      apiKeyValue: 'Key',
      user: 'User',
      password: 'Password',
      tls: 'TLS',
      skipVerification: 'Do not verify the certificate',
      skipVerificationHelp: 'Only for test servers with self-signed certificates.',
      trustedCaPem: 'Trusted CA (PEM)',
      runtime: 'Runtime',
      timeoutSeconds: 'Timeout (seconds)',
      initTimeoutSeconds: 'Start timeout (seconds)',
      defaultArgs: 'Default arguments',
      defaultArgsHelp: 'One KEY=value per line — added to every tool call unless the model sets the argument.',
      lease: 'Lease',
      leaseHelp: 'Optional name of a lease definition that caps concurrent sessions.',
      leaseInline: 'The lease is defined inline — edit it in the JSON view.',
      loginTitle: 'Login',
      loginNote: {
        user: 'Each user logs in with their own account. Others log in here or under Connected accounts.',
        project: 'One account for everybody working in the project the tool is called in. Only project admins can log in.',
        tenant: 'One account for the whole tenant. Only tenant admins can log in.',
      },
      status: {
        CONNECTED: 'Logged in',
        NOT_CONNECTED: 'Not logged in',
        EXPIRED: 'Login expired',
      },
      login: 'Log in',
      relogin: 'Log in again',
      logout: 'Log out',
      confirmLogout: 'Log out of the MCP server "{name}"? Its tools are no longer available until somebody logs in again.',
      loggedIn: 'Logged in. The tools of the server are available from the next turn on.',
      loggedOut: 'Logged out.',
      testTitle: 'Connection test',
      testHelp: 'Connects as you and lists the tools of the server. Switch off tools the model should not see.',
      savedStateNote: 'Test and login use the saved state — apply your changes first.',
      testRun: 'Test',
      testOk: 'Connected — {n} tool | Connected — {n} tools',
      testToolsNote: 'Switched-off tools are saved as disabled sub-tools.',
      subToolToggle: 'Offer {name} to the model',
      discoveryTitle: 'Login server',
      discoveryIssuer: 'Issuer',
      discoveryRegistration: 'Registration',
      registration: {
        cimd: 'Client metadata document',
        dcr: 'Dynamic registration',
        manual: 'Configured client ID',
        none: 'Not possible — set a client ID',
      },
    },
  },

  toolTemplates: {
    pageTitle: 'Tool Templates',
    intro:
      'Curated tool packs (Jira, IMAP, SMTP, …). Pick one, fill in the inputs, and it is installed into this scope — passwords are stored encrypted.',
    loading: 'Loading…',
    searchPlaceholder: 'Search templates…',
    apply: 'Apply',
    previouslyApplied: 'Previously applied on {at} by {by}. Form pre-filled — adjust and re-apply to update. Password fields stay blank for security.',
    noInputs: 'This template has no inputs — apply to install it.',
    empty: {
      body: 'No templates available — the catalog lives at _tenant/config/tool-templates.yaml.',
    },
    applyFailed: 'Apply failed.',
    unknownUser: 'unknown',
    connectProvider: 'Connect {provider}…',
    openConnectedAccounts: 'Open connected accounts',
  },

  oauthConsent: {
    pageTitle: 'Allow access',
    loading: 'Loading…',
    missingRequest: 'This page needs a sign-in request. Start the sign-in again from the program.',
    expired: 'This sign-in request has expired or belongs to another user. Start the sign-in again from the program.',
    wrongTenant: 'This sign-in request is for the tenant "{tenant}", but you are signed in to another one.',
    signInToTenant: 'Sign in to {tenant}',
    headline: '"{client}" wants access to your account',
    firstParty: {
      headline: 'Sign in "{client}" on this computer?',
      warning:
        'The program gets full access to your account — everything you can do here. The access goes to a program on this computer (localhost): only allow it if you just started the sign-in yourself, e.g. with /login --browser.',
    },
    client: {
      dcr: 'The program chose this name itself — it is not verified.',
      cimd: 'The program is identified by its metadata document {url}.',
      firstParty: 'This is a Vancetope program.',
    },
    accessLabel: 'Access to',
    accountLabel: 'Acting as',
    redirectLabel: 'Access goes to',
    door: {
      mcpProject: 'The documents of project "{project}" (MCP)',
      mcp: 'All MCP tools of tenant "{tenant}" — everything your account may do there',
      agents: 'The agents door of tenant "{tenant}"',
      account: 'Your whole account in tenant "{tenant}"',
    },
    loopbackWarning:
      'The access goes to a program on this computer (localhost). Only approve if you started this sign-in yourself just now.',
    revokeHint: 'You can revoke the access at any time under Connected Accounts.',
    approve: 'Allow',
    decline: 'Decline',
    approveArming: 'Allow becomes available once this window is in the foreground.',
  },

  connectedApps: {
    title: 'Apps with access to your account',
    intro:
      'Programs that can act as you: OAuth sign-ins (e.g. an MCP client) and integration tokens. Revoking stops them within seconds.',
    loading: 'Loading…',
    loadFailed: 'Could not load the connected apps.',
    revokeFailed: 'Revoking failed.',
    revoke: 'Revoke',
    confirmRevoke: 'Revoke the access of "{name}"? The program will have to sign in again.',
    lastUsed: 'Last used: {when}',
    tokenSliding: 'Sliding · renews on use ({days}d idle)',
    never: 'never',
    tokenBadge: 'Token',
    empty: {
      headline: 'No connected apps',
      body: 'No outside program currently has access to your account.',
    },
    scope: {
      mcpProject: 'MCP documents of project "{project}"',
      mcp: 'All MCP tools',
      agents: 'Agents door',
      account: 'Whole account',
    },
    backup: {
      title: 'Backup access',
      intro:
        'Mint an integration token for the local backup tool (vancetope-backup). '
        + 'The token can read all documents you can read, and renews itself automatically while a backup runs.',
      profile: 'Profile',
      profileSurfaces: 'What this token can do:',
      labelLabel: 'Label',
      labelPlaceholder: 'e.g. "Mike\'s laptop"',
      idleDaysLabel: 'Idle days',
      idleDaysHelp:
        'Token renews on every successful backup. Dies after {days} days without one.',
      idleDaysFixed:
        'This profile uses a fixed lifetime — idleDays does not apply.',
      idleDaysRange: 'idleDays must be between {min} and {max}.',
      submit: 'Mint backup token',
      loadingProfiles: 'Loading profiles…',
      profilesLoadFailed: 'Could not load the integration token profiles.',
      mintFailed: 'Could not mint the token.',
      noProfiles: {
        headline: 'No integration profiles available',
        body:
          'This brain does not expose any integration profiles — ask the operator to enable one.',
      },
      tokenTitle: 'Your token — shown only once',
      oneTimeWarning:
        'Copy this token now. We do not store it, so once you leave this page we cannot show it again. '
        + 'If you lose it, revoke the token and mint a new one.',
      copy: 'Copy',
      copied: 'Copied',
      dismiss: 'I have copied the token',
      usage:
        'Use it in the backup tool: when init asks for a token, paste the string above into ~/.vancetope/backup/backup.yaml.',
    },
  },

  connectedAccounts: {
    pageTitle: 'Connected Accounts',
    loading: 'Loading…',
    intro:
      'Connect your accounts at external providers (Slack, Google, Atlassian, …). '
      + 'Tools that talk to these providers will use your token automatically.',
    statusConnected: 'connected',
    statusUnconnected: 'not connected',
    connect: 'Connect',
    reconnect: 'Reconnect',
    disconnect: 'Disconnect',
    confirmDisconnect:
      'Disconnect {provider}? Stored tokens will be deleted from the server. Tokens at the provider stay until you revoke them there.',
    empty: {
      headline: 'No providers configured',
      body: 'Ask your tenant administrator to set up OAuth providers for this workspace.',
    },
    banner: {
      justConnected: 'Connected to {provider}.',
    },
  },

  oauthProviders: {
    pageTitle: 'OAuth Providers',
    loading: 'Loading…',
    breadcrumbRoot: 'OAuth Providers',
    confirmDelete:
      'Delete OAuth provider "{id}"? Users connected to it lose access until reconnected.',
    confirmRemoveSecret:
      'Remove the stored client secret? No new connections will work until you set a new one.',
    sidebar: {
      providersLabel: 'Providers',
      noProvidersHeadline: 'No OAuth providers',
      noProvidersBody: 'Click + New to add one.',
      secretSet: 'secret set',
      secretMissing: 'secret missing',
    },
    detail: {
      clientIdLabel: 'clientId:',
      save: 'Save',
      delete: 'Delete',
    },
    cards: {
      yamlTitle: 'Configuration (YAML)',
      yamlHelp:
        'The YAML body lands as document oauth/<providerId>.yaml in the _tenant project. '
        + 'clientSecret must NOT appear here — manage it via the secret field below.',
      secretTitle: 'Client secret',
      secretIsSet: 'A client secret is stored as a tenant PASSWORD setting.',
      secretIsMissing: 'No client secret stored yet — connect attempts will fail.',
      newSecretLabel: 'New client secret',
      newSecretHelp:
        'Type a new value to set or rotate. Leave blank to keep the current one untouched.',
      removeSecret: 'Remove stored secret',
    },
    empty: {
      headline: 'Pick a provider',
      body: 'Select a provider from the sidebar to edit it, or create a new one with + New.',
    },
    banner: {
      saved: 'Saved.',
      deleted: 'Deleted.',
      secretRemoved: 'Client secret removed.',
      created: 'Created provider "{id}". Fill in clientId, scopes and add the client secret.',
    },
    newModal: {
      title: 'New OAuth provider',
      idLabel: 'Provider id',
      idHelp:
        "Lower-case alphanumerics, '-' or '_'. Becomes the path stem and the settings-key prefix (e.g. slack, keycloak-acme).",
      idRequired: 'Provider id is required.',
      idPattern:
        "Provider id must start with a letter/digit and contain only lower-case letters, digits, '-' and '_'.",
      idAlreadyExists: 'Provider "{id}" already exists.',
      stubInfo:
        'A stub YAML will be created. Edit it to set the type (oidc / generic-oauth2 / slack / atlassian / google), endpoints and scopes, then set the client secret.',
      cancel: 'Cancel',
      create: 'Create',
      createFailed: 'Failed to create the provider.',
    },
  },

  projectMembers: {
    title: 'Members',
    intro: 'Who works in this project, and with which role. A team as member gives the role to every member of the team — that is also how a project is opened to everyone. Tenant admins have full rights here without being members.',
    loading: 'Loading members…',
    empty: 'No members yet.',
    subjectType: 'Type',
    subjectId: 'User or team name',
    role: 'Role',
    add: 'Add member',
    added: '{name} is now {role}.',
    remove: 'Remove member',
    confirmRemove: 'Remove {name} from this project?',
    subject: {
      USER: 'User',
      TEAM: 'Team',
    },
    roles: {
      READER: 'Reader',
      MEMBER: 'Member',
      ADMIN: 'Admin',
    },
  },
  users: {
    pageTitle: 'Users & Teams',
    loading: 'Loading…',
    none: '—',
    breadcrumbs: {
      userPrefix: 'User: {name}',
      teamPrefix: 'Team: {name}',
    },
    sidebar: {
      usersTitle: 'Users',
      teamsTitle: 'Teams',
      showInternalUsers: 'Show internal users',
      memberCountSingular: '{count} member',
      memberCountPlural: '{count} members',
      disabledSuffix: '· disabled',
    },
    empty: {
      headline: 'Pick a user or team',
      body: 'Use the lists on the left, or create a new entry with + User / + Team.',
    },
    role: {
      cardTitle: 'Tenant role',
      intro: 'What this user may do in the tenant beyond the projects they are a member of.',
      label: 'Role',
      save: 'Set role',
      saved: 'Role set to {role}.',
      options: {
        USER: 'User',
        CREATOR: 'Creator',
        ADMIN: 'Admin',
        TENANT_ADMIN: 'Tenant admin',
      },
      descriptions: {
        USER: 'Works in the projects they are a member of.',
        CREATOR: 'Also creates projects and becomes their project admin.',
        ADMIN: 'Also manages users and teams and has full rights in every project — except the tenant configuration.',
        TENANT_ADMIN: 'Also changes the tenant configuration and appoints tenant admins.',
      },
    },
    user: {
      cardTitle: 'User: {name}',
      ownAccountNote: 'This is your own account. Disable / delete are blocked here.',
      nameLabel: 'Name',
      nameImmutable: 'User name is immutable.',
      titleLabel: 'Title',
      emailLabel: 'Email',
      statusLabel: 'Status',
      createdLabel: 'Created',
      delete: 'Delete',
      setPassword: 'Set password…',
      save: 'Save',
      cantDisableSelf: 'You cannot disable your own account.',
      cantDeleteSelf: 'You cannot delete your own account.',
      saved: 'User saved.',
      deleted: 'User "{name}" deleted.',
      confirmDelete:
        'Delete user "{name}"? Memberships in teams are not auto-cleaned.',
      statusOptions: {
        active: 'ACTIVE',
        disabled: 'DISABLED',
        pending: 'PENDING',
      },
      settings: {
        cardTitle: 'User settings',
        intro:
          'Per-user settings live on the synthetic _user_{name} system project. They take precedence over project and tenant settings in the cascade — useful for per-user model preferences, API keys, language defaults.',
        noSettingsHeadline: 'No settings',
        noSettingsBody: 'Add a key/value below to override tenant defaults for this user.',
        valueLabel: 'Value',
        newPasswordLabel: 'New password',
        passwordEmptyToClear: '(leave empty to clear)',
        descriptionLabel: 'Description',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        empty: '(empty)',
        confirmDelete: 'Delete setting "{key}"?',
        addTitle: 'Add setting',
        keyLabel: 'Key',
        keyPlaceholder: 'e.g. ai.default.model',
        typeLabel: 'Type',
        passwordLabel: 'Password',
        descriptionOptional: 'Description (optional)',
        add: 'Add',
      },
    },
    team: {
      cardTitle: 'Team: {name}',
      nameLabel: 'Name',
      nameImmutable: 'Team name is immutable.',
      titleLabel: 'Title',
      enabledLabel: 'Enabled',
      membersLabel: 'Members',
      membersPlaceholder: 'One username per line. Removing a line drops the member.',
      memberHelpSingular: '{count} member',
      memberHelpPlural: '{count} members',
      createdLabel: 'Created',
      delete: 'Delete',
      save: 'Save',
      saved: 'Team saved.',
      deleted: 'Team "{name}" deleted.',
      confirmDelete: 'Delete team "{name}"?',
    },
    helpPanel: {
      title: 'User & team admin',
      loading: 'Loading…',
      unavailable: 'Help unavailable: {error}',
      empty: 'No help content.',
    },
    createUser: {
      title: 'New user',
      nameLabel: 'Name',
      nameHelp: "Lower-case alphanumerics with optional '.', '-' or '_'.",
      titleLabel: 'Title',
      emailLabel: 'Email',
      passwordLabel: 'Password (optional)',
      passwordHelp:
        'Empty creates a passwordless account that cannot log in until you set one. Otherwise at least 10 characters.',
      cancel: 'Cancel',
      create: 'Create',
      nameInvalid: 'Name must be lower-case alphanumerics with optional ".", "-" or "_".',
      alreadyExists: 'A user named "{name}" already exists.',
      createFailed: 'Failed to create user.',
      created: 'User "{name}" created.',
      seats: 'Seats: {active} of {limit} in use.',
      seatsFull: 'All {limit} seats are in use ({active}) — a new user is refused. Disable or delete a user, or raise the limit in the settings form "User Quota".',
    },
    createTeam: {
      title: 'New team',
      nameLabel: 'Name',
      nameHelp: "Lower-case alphanumerics with optional '-' or '_'.",
      titleLabel: 'Title',
      membersLabel: 'Initial members',
      membersPlaceholder: 'One username per line.',
      cancel: 'Cancel',
      create: 'Create',
      nameInvalid: 'Name must be lower-case alphanumerics with optional "-" or "_".',
      alreadyExists: 'A team named "{name}" already exists.',
      createFailed: 'Failed to create team.',
      created: 'Team "{name}" created.',
    },
    setPassword: {
      title: 'Set password',
      intro: 'Replaces the password for {name}. Plaintext is hashed server-side.',
      newPasswordLabel: 'New password',
      newPasswordHelp: 'At least 10 characters.',
      repeatPasswordLabel: 'Repeat password',
      cancel: 'Cancel',
      submit: 'Set password',
      required: 'Password is required.',
      mismatch: 'Passwords do not match.',
      failed: 'Failed to set password.',
      updated: 'Password updated for "{name}".',
    },
  },

  researchSource: {
    protocols: {
      arxiv: 'arXiv',
      hackernews: 'Hacker News',
      ode: 'Ode (foreign search service)',
      openalex: 'OpenAlex',
      openlibrary: 'Open Library',
      pubmed: 'PubMed',
      serper: 'Serper.dev (Google SERP)',
      wikipedia: 'Wikipedia',
    },
    form: {
      sectionSource: 'Source',
      protocol: 'Protocol',
      protocolHelp: 'Which search protocol this endpoint speaks.',
      protocolCustom: 'Protocol id',
      protocolCustomHelp:
        'Must match a protocol the server ships — an unknown id keeps the source inert.',
      baseUrl: 'Endpoint',
      baseUrlHelp: 'Base URL of the service, e.g. https://google.serper.dev.',
      apiKey: 'API key',
      apiKeyHelp:
        'Either a reference ({ref}) or a declared literal ({literal}). The form stores what you type — it never resolves either.',
      contactEmail: 'Contact email',
      contactEmailHelp: 'Politeness contact the provider asks for (openalex, pubmed).',
      capsTtlSeconds: 'Capabilities cache TTL (seconds)',
      capsTtlSecondsHelp: 'Overrides what the source itself suggests. 0 = ask every time.',
      enabled: 'Enabled',
      enabledHelp: 'A disabled source stays configured but takes no part in routing.',
      draftWarning:
        'This document is not under _vance/config/research/ — the research dispatcher only reads that folder, so the source stays inert where it is.',
      preserved:
        '{count} further field(s) in this document are kept unchanged — edit them in the raw editor.',
    },
  },
  mountSource: {
    protocols: {
      local: 'Local directory',
      demo: 'Demo source',
      ode: 'Ode (foreign file service)',
    },
    form: {
      sectionMount: 'Mount',
      protocol: 'Protocol',
      protocolHelp: 'Which mount protocol this source speaks.',
      protocolCustom: 'Protocol id',
      protocolCustomHelp:
        'Must match a protocol the server serves — an unknown id leaves the mount inactive.',
      baseUrl: 'Endpoint',
      baseUrlHelp: 'Base URL of the service. Not needed for the local protocol.',
      apiKey: 'API key',
      apiKeyHelp:
        'Either a reference ({ref}) or a declared literal ({literal}). The form stores what you type — it resolves neither.',
      rootDir: 'Root directory',
      rootDirHelp: 'The directory the mount exposes — an absolute path on the server.',
      writable: 'Writable',
      writableHelp:
        'Allows writes and deletes into the mounted tree. Default: read-only.',
      enabled: 'Enabled',
      enabledHelp: 'A disabled mount stays configured but does not appear in the tree.',
      draftWarning:
        'This document is not under _vance/config/mounts/ — the mount factory only reads that folder, so the mount stays inert where it is.',
      preserved:
        '{count} further field(s) in this document are kept unchanged — edit them in the raw editor.',
    },
  },
  modelDoc: {
    sizes: {
      SMALL: 'Small',
      LARGE: 'Large',
    },
    capabilities: {
      VISION: 'Image input (vision)',
      PDF: 'PDF input',
      THINKING: 'Thinking model',
      MID_CONVERSATION_SYSTEM: 'System messages mid-conversation',
    },
    form: {
      draftWarning:
        'This document is not under _vance/model/ — the model catalog only reads that tree, so the document stays inert where it is.',
      sectionIdentity: 'Identity',
      displayName: 'Display name',
      displayNameHelp: 'Empty = inherits from the outer layer.',
      wireName: 'Wire name',
      wireNameHelp:
        'Only needed when it cannot be derived from the filename (e.g. Ollama tags "qwen3:30b"). Empty = the path is the name.',
      sectionLimits: 'Limits',
      contextWindowTokens: 'Context window (tokens)',
      contextWindowTokensHelp: 'Empty = the catalog falls back to its conservative default.',
      defaultMaxOutputTokens: 'Default output cap (tokens)',
      defaultMaxOutputTokensHelp: 'Empty = inherits.',
      size: 'Size',
      sizeHelp: 'Drives recipe / process selection; empty = inherits.',
      sizeCustom: 'Custom size',
      timeoutSeconds: 'Timeout (seconds)',
      timeoutSecondsHelp: 'Empty = inherits.',
      sectionPricing: 'Pricing',
      pricingHelp:
        'The three known keys of the pricing block; further keys are kept unchanged.',
      pricingCurrency: 'Currency',
      pricingInputPerMTok: 'Input per MTok',
      pricingOutputPerMTok: 'Output per MTok',
      preserved:
        '{count} further field(s) in this document are kept unchanged — edit them in the raw editor.',
    },
  },
  providerDoc: {
    form: {
      draftWarning:
        'This document is not under _vance/model/ — the model catalog only reads that tree, so the instance stays inert where it is.',
      sectionProvider: 'Provider instance',
      intro:
        'The sidecar declares once how this instance speaks — models under it then resolve without a setting of their own.',
      displayName: 'Display name',
      displayNameHelp: 'Empty = inherits.',
      wireType: 'Wire protocol',
      wireTypeHelp: 'Without this field the instance resolves no model.',
      wireTypeCustom: 'Wire protocol id',
      authType: 'Credential shape',
      authTypeHelp: 'How the key travels with requests.',
      authTypeCustom: 'Credential shape id',
      baseUrl: 'Endpoint',
      baseUrlHelp: 'Empty = inherits or the protocol default.',
      preserved:
        '{count} further field(s) in this document are kept unchanged — edit them in the raw editor.',
    },
  },
  scheduler: {
    pageTitle: 'Scheduler',
    pickProject: 'Pick a session or project to see its schedulers.',
    tenantWide: '_vance (tenant defaults)',
    projectLabel: 'Project',
    listLabel: 'Schedulers',
    policyHours:
      'Cron schedulers on this server run at most once per hour, at a minute the server picks per scheduler to spread the load — not at an exact minute.',
    refresh: 'Refresh',
    new: 'New scheduler…',
    create: 'Create',
    enabled: 'enabled',
    disabled: 'disabled',
    emptyTitle: 'No schedulers',
    emptyBody: 'Use New scheduler… to create one in this project.',
    selectTitle: 'Pick a scheduler',
    selectBody: 'Choose an entry on the left or create a new one.',
    newTitle: 'New scheduler',
    nameLabel: 'Name',
    namePlaceholder: 'morning-briefing',
    namePatternHint: 'Lowercase, alphanumeric + "-_", max 64 chars.',
    invalidNameHint: 'Name must match the pattern above.',
    duplicateNameHint: 'A scheduler with this name already exists.',
    deleteTitle: 'Delete scheduler?',
    deleteBody: 'Permanently remove scheduler "{name}"? Past runs stay in the event log.',
    runHistory: 'Run history',
    noEvents: 'No events yet.',
    createdHint: 'Created "{name}". Edit the YAML and save.',
    savedHint: 'Saved "{name}".',
    deletedHint: 'Deleted "{name}".',
    refreshedHint: 'Re-registered {count} scheduler(s).',
    saveFailed: 'Save failed.',
    fire: 'Run now',
    fireHint: 'Trigger this scheduler immediately. Works for disabled schedulers too (cron stays paused; the manual run still goes through). Log carries trigger=manual.',
    firedHint: 'Triggered "{name}" — correlationId {correlationId}.',

    form: {
      sectionWhat: 'What happens',
      description: 'Description',
      descriptionHelp: 'One sentence — shows in the scheduler list and the web editor.',
      targetLabel: 'Trigger target',
      target_recipe: 'Recipe (spawns a process)',
      target_workflow: 'Workflow (Magrathea)',
      target_script: 'Script (JS)',
      targetName: 'Name',
      recipeHelp: 'e.g. default, analyze, marvin — resolved via the project cascade.',
      scriptSource: 'Script source',
      scriptPath: 'Script path',
      overlap: 'Overlap policy',
      overlapHelp: 'What happens when the previous run is still active.',
      overlap_skip: 'Skip — discard the tick',
      overlap_queue: 'Queue — run after the previous one',
      overlap_cancelPrevious: 'Cancel — stop the previous run',
      initialMessage: 'Prompt per run',
      initialMessageHelp: 'First user message for the spawned process. Empty = recipe default.',
      sectionWhen: 'When it fires',
      mode: 'Schedule',
      mode_hourly: 'Hourly',
      mode_daily: 'Daily',
      mode_weekly: 'Weekly',
      mode_monthly: 'Monthly',
      mode_once: 'Once',
      mode_other: 'Other (cron expression)',
      everyHours: 'Every N hours',
      everyHoursHelp: 'Fires at the minute below, every N hours.',
      minute: 'Minute',
      minuteHelp: 'Fires at this minute of every hour.',
      timeOfDay: 'Time of day',
      monthDay: 'Day of month',
      monthDayHelp: 'Months lacking the day (February, the 31st) silently skip the run.',
      onceAt: 'Point in time',
      onceAtHelp: 'Fires once, then the document moves to the trash.',
      cron: 'Cron expression',
      cronHelp: 'Quartz 6-field: <sec> <min> <hour> <day-of-month> <month> <day-of-week>.',
      policyHours:
        'This server runs schedulers at most once per hour, and not at an exact minute: it picks a fixed minute per scheduler to spread the load. The minute and seconds you enter here are not honoured; the hour, day and weekday are.',
      policyMinutes:
        'This server runs schedulers at most once per minute: the seconds field is ignored and treated as 0.',
      timezone: 'Timezone',
      timezoneHelp: 'IANA zone (e.g. Europe/Berlin). When empty, UTC applies.',
      enabled: 'Enabled',
      enabledHelp: 'Paused schedulers keep their registration but do not fire.',
      sectionIdentity: 'Identity',
      runAs: 'Runs as (runAs)',
      runAsHelp: 'User whose inbox receives errors and questions. Empty = the document creator.',
      draftHint:
        'This scheduler definition is not under _vance/scheduler/ — it is a draft and does not fire. Move it there to activate it.',
    },
  },

  ursahooks: {
    pickProject: 'Pick a session or project to see its hooks.',
    tenantWide: '_vance (tenant defaults)',
    projectLabel: 'Project',
    listLabel: 'Hooks',
    refresh: 'Refresh',
    new: 'New hook…',
    create: 'Create',
    enabled: 'enabled',
    disabled: 'disabled',
    emptyTitle: 'No hooks',
    emptyBody: 'Use New hook… to create one in this project.',
    selectTitle: 'Pick a hook',
    selectBody: 'Choose an entry on the left or create a new one.',
    newTitle: 'New hook',
    eventLabel: 'Lifecycle event',
    nameLabel: 'Name',
    namePlaceholder: 'notify-slack',
    namePatternHint: 'Lowercase, alphanumeric + "-_", max 64 chars.',
    invalidNameHint: 'Name must match the pattern above.',
    duplicateNameHint: 'A hook with this event/name already exists.',
    deleteTitle: 'Delete hook?',
    deleteBody: 'Permanently remove hook "{event}/{name}"? Past runs stay in the event log.',
    runHistory: 'Run history',
    noEvents: 'No events yet.',
    createdHint: 'Created "{name}". Edit the YAML and save.',
    savedHint: 'Saved "{name}".',
    deletedHint: 'Deleted "{name}".',
    refreshedHint: 'Re-registered {count} hook(s).',
    saveFailed: 'Save failed.',
  },

  settingForms: {
    title: 'Setting Forms',
    tenantWide: '_tenant (tenant-wide)',
    projectLabel: 'Project',
    formsLabel: 'Forms',
    emptyHeadline: 'No forms available',
    emptyBody:
      'Setting Forms are YAML files under _vance/setting_forms/ that configure settings in a structured way.',
    pickFormHeadline: 'Pick a form',
    pickFormBody: 'Choose a form from the list on the left to edit it.',
    currentValuesTitle: 'Current values (cascade)',
    computedTitle: 'Additional computed settings',
    appliedTitle: 'Applied',
    previewTitle: 'Preview',
    resetTitle: 'Reset',
    noChanges: 'No changes.',
    apply: 'Save',
    preview: 'Preview',
    reset: 'Reset',
    confirmReset: 'Delete every key this form references on this layer?',
    unset: '(not set)',
    explicitEmpty: '(empty — does not inherit)',
    conditional: 'conditional',
    sourceTenant: 'tenant',
    sourceUser: 'user "{user}"',
    sourceProject: 'project "{project}"',
    actions: {
      write: 'WRITE',
      delete: 'DELETE',
      skip: 'SKIP',
    },
  },

  scopes: {
    pageTitle: 'Scopes',
    loading: 'Loading…',
    common: {
      name: 'Name',
      title: 'Title',
      enabled: 'Enabled',
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
      create: 'Create',
      empty: '(empty)',
      none: '—',
      noGroup: '(no group)',
      delete: 'Delete',
      disabled: '(disabled)',
      archived: '(archived)',
    },
    sidebar: {
      tenant: 'Tenant',
      projectGroups: 'Project Groups',
      addGroup: '+ Group',
      addProject: '+ Project',
      ungroupedProjects: 'Ungrouped Projects',
    },
    breadcrumbs: {
      groupPrefix: 'Group: {name}',
      projectPrefix: 'Project: {name}',
    },
    tenant: {
      cardTitle: 'Tenant',
      nameImmutable: 'Tenant name is immutable.',
      saved: 'Tenant saved.',
    },
    group: {
      cardTitle: 'Group: {name}',
      reservedNote: 'This group is reserved for archived projects and cannot be deleted.',
      nameImmutable: 'Group name is immutable.',
      delete: 'Delete',
      saved: 'Group saved.',
      created: 'Group "{name}" created.',
      deleted: 'Group "{name}" deleted.',
      confirmDelete: 'Delete group "{name}"? This is only possible if the group is empty.',
    },
    project: {
      cardTitle: 'Project: {name}',
      archivedNote:
        'This project is archived. It does not run, but its documents and settings are kept and its metadata can still be edited. Unarchive brings it back with an empty workspace.',
      archivedReturnsTo: 'Unarchive returns it to the group "{group}".',
      nameImmutable: 'Project name is immutable.',
      groupLabel: 'Group',
      archive: 'Archive',
      unarchive: 'Unarchive',
      statusLabel: 'Status',
      podLabel: 'Pod',
      claimedLabel: 'Claimed',
      createdLabel: 'Created',
      placementPendingLabel: 'Waiting since',
      lifecycleLabel: 'Lifecycle',
      lifecyclePermanentNote: 'kept on a pod for good; set by the operator',
      lifecycleEphemeralNote:
        'does not start on its own — this project\'s scheduler and hooks do not run',
      placementPendingBadge: 'waiting for a pod',
      placementPendingNote:
        'This project has been created but no brain process matches it yet — its placement '
        + 'selector requires a pod that is not available, or every matching pod is full. '
        + 'It stays here and starts as soon as one appears; nothing is lost.',
      saved: 'Project saved.',
      created: 'Project "{name}" created.',
      createdPendingPlacement:
        'Project "{name}" created — waiting for a matching pod before it can start.',
      createdWithKitError: 'Project "{name}" created, but kit "{kit}" install failed: {error}',
      archived: 'Project archived.',
      unarchived: 'Project unarchived.',
      confirmArchive:
        'Archive project "{name}"? It will be moved to the "archived" group. Documents and settings are kept, '
        + 'but its workspace (checkouts, working files) is deleted and does not come back on unarchive.',
      languagesCardTitle: 'Languages',
      languagesDescription:
        'Per-project language overrides. When unset, resolution falls through to user / tenant defaults.',
      languageNotSet: 'Not set',
      chatLanguageLabel: 'Assistant language (chat)',
      chatLanguageHelp:
        'Overrides the user-profile setting. Example: an English code-review project owned by a German-speaking user.',
      contentLanguageLabel: 'Content language (documents, insights, memory)',
      contentLanguageHelp:
        'Language the assistant writes content in. No user layer by design — content belongs to the project.',
      copy: {
        action: 'Copy…',
        title: 'Copy project "{name}"',
        description:
          'Creates a new project holding this one\'s documents and settings. Trash, logs '
          + 'and mounted documents under _ext/ are left out.',
        nameLabel: 'Name of the new project',
        nameHelp: 'Automatically normalised to lower-case. Immutable.',
        includeSecrets: 'Copy encrypted settings',
        includeSecretsHelp:
          'Off by default, and deliberately so: a copy is usually read by more people '
          + 'than the original. Left off, the report lists the keys that have to be set by hand.',
        notCopiedHint:
          'Permissions are not copied — access to the copy has to be granted again. '
          + 'Sessions, chat history, inbox threads and the workspace stay behind as well.',
        submit: 'Copy',
        done: 'Project "{name}" created.',
        documentsCopied: 'Documents copied',
        documentsExcluded: 'Documents excluded',
        documentsFailed: 'Documents failed',
        settingsCopied: 'Settings copied',
        secretsCopied: 'Secrets copied',
        secretsSkipped: 'Secrets left behind',
        secretsSkippedHelp: 'These keys have to be set by hand in the new project.',
        failures: 'Failed',
        notCopied: 'Not copied',
        open: 'Open the copy',
      },
    },
    sessionGroups: {
      cardTitle: 'Session Groups',
      description:
        "Per-user grouping of this project's sessions — UI organisation only. Each user sees only their own groups.",
      empty: 'No session groups in this project yet.',
      nameLabel: 'Name',
      nameHint: 'Automatically normalised to lower-case. Immutable.',
      titleLabel: 'Title',
      add: 'Create group',
      sessionCount: '{count} sessions',
      rename: 'Rename',
      delete: 'Delete',
      created: 'Session group "{name}" created.',
      renamed: 'Session group saved.',
      deleted: 'Session group "{name}" deleted.',
      confirmDelete:
        'Delete session group "{name}"? Its sessions are only removed from the group, not deleted.',
    },
    kit: {
      cardTitle: 'Kit',
      loading: 'Loading kit status…',
      none: 'No kit installed in this project.',
      versionPrefix: 'v{version}',
      origin: 'Origin',
      vendor: 'Vendor',
      license: 'Licence',
      licensedTo: 'Licensed to',
      licenseExpires: 'Licence expires',
      licenceExpired:
        'The licence has expired. The kit stays installed and keeps working; only updates stop.',
      licenceExpiringSoon: 'Licence expires on {date}.',
      signature: {
        verified: 'signed',
        verifiedHelp: 'Origin was checked at install time and was valid.',
        failed: 'bad signature',
        failedHelp:
          'Signature verification failed, but the source permits that. Origin and content are unverified.',
      },
      path: 'Path',
      branch: 'Branch',
      commit: 'Commit',
      installed: 'Installed',
      documents: 'Documents',
      settings: 'Settings',
      tools: 'Tools',
      inherits: 'Inherits',
      isSource: 'This project is the source of kit "{name}".',
      configure: 'Rules…',
      promote: 'Develop this kit',
      uninstall: 'Uninstall',
      updateAll: 'Update all',
      library: {
        title: 'From your library',
        loading: 'Loading your library…',
        choose: 'Use this',
        alreadyInstalled: '(installed)',
        notDebackupable: 'Your licence does not currently entitle any published version.',
      },
      projects: {
        title: 'From a project',
        description:
          'Projects of this tenant that are kit sources themselves. Takes their current '
          + 'state — for a kit that has not been pushed yet.',
        choose: 'Use this',
      },
      confirmUninstall:
        'Uninstall kit "{name}"? The record goes; the files stay for now.',
      confirmUninstallPrune:
        'Also delete the documents and settings "{name}" brought along? Cancel keeps them.',
      confirmPromote:
        'Make this project the source of kit "{name}"? The kit can then be edited here and exported. A project can be the source of exactly one kit.',
      uninstalled_msg: 'Kit "{name}" uninstalled.',
      promoted_msg: 'Project is now the source of kit "{name}".',
      updatedAll_msg: '{count} kits updated.',
      config: {
        title: 'Rules for "{name}"',
        defaultAction: 'Default behaviour on update',
        defaultActionHelp:
          'Applies to everything no rule matches. "Keep" refreshes only as long as you have not changed the file yourself.',
        sortIndex: 'Order',
        sortIndexHelp:
          'Higher wins when two kits ship the same file. Leave empty for install order, i.e. the most recently installed kit wins.',
        rules: 'Exceptions',
        rulesHelp:
          'The last matching rule wins — like .gitignore. Server tools are documents: server-tools/*.yaml.',
        addRule: 'Add rule',
        noRules: 'No exceptions — the default applies everywhere.',
        namespace: 'Namespace',
        namespaceDocument: 'Document',
        namespaceSetting: 'Setting',
        pattern: 'Pattern',
        action: 'Behaviour',
        actionKeep: 'Keep (protect my edits)',
        actionOverwrite: 'Overwrite (kit always wins)',
        actionIgnore: 'Ignore (never touch)',
        actionMerge: 'Merge (reconcile my edits with the kit)',
        saved_msg: 'Rules saved.',
      },
      install: 'Install…',
      update: 'Update…',
      export: 'Export…',
      installed_msg: 'Kit installed.',
      updated_msg: 'Kit updated.',
      applied_msg: 'Kit applied.',
      exported_msg: 'Kit exported.',
      lastOperation: 'Last operation: {mode}',
      lastOperationVersion: 'Last operation: {mode} → {version}',
      docsAdded: '+ {count} documents',
      docsUpdated: '~ {count} documents',
      docsRemoved: '− {count} documents',
      settingsTouched: '{count} settings touched',
      toolsTouched: '{count} tools touched',
      passwordsSkipped: '⚠ {count} passwords skipped',
      dialog: {
        installTitle: 'Install kit',
        updateTitle: 'Update kit',
        exportTitle: 'Export kit',
        repoUrl: 'Repo URL',
        repoUrlHelp: 'https://… or file:///…',
        repoUrlReuseHelp: 'Leave empty to reuse manifest origin.',
        subPath: 'Sub-path',
        subPathHelp: 'Optional. Defaults to repo root.',
        branchLabel: 'Branch',
        branchHelp: 'Defaults to main.',
        commitSha: 'Commit SHA',
        commitShaHelp: 'Optional. Pins a specific commit.',
        authToken: 'Auth token',
        authTokenHelp: 'Optional. Required for private HTTPS repos.',
        vaultPassword: 'Vault password',
        vaultPasswordExportHelp: 'Required only when the kit ships PASSWORD-settings.',
        vaultPasswordImportHelp: 'Decrypts PASSWORD-settings shipped with the kit.',
        commitMessage: 'Commit message',
        commitMessageHelp: 'Optional. Defaults to vance-export: <kit>@<sha>.',
        prune: 'Prune removed artefacts',
        pruneHelp:
          'Also delete files / settings / tools that the previous kit version had but the new one no longer ships.',
        keepPasswords: 'Keep existing passwords',
        keepPasswordsHelp:
          'Skip PASSWORD-settings shipped with the kit so existing project credentials are preserved.',
        trackInstall: 'Manage as an installed kit',
        trackInstallHelp:
          'On (default): the kit gets a record under _vance/kits/installed/ and stays updatable. Off: one-off splat without management — useful for tunings (extra tools / settings) that should not be carried along.',
        writeManifest: 'This project is the kit source',
        writeManifestHelp:
          'Off (default). On: mark the project as the source of this kit (_vance/kits/manifest.yaml) so it can be exported — for kit developers editing the kit here. A project can be the source of exactly one kit.',
        submitInstall: 'Install',
        submitUpdate: 'Update',
        submitExport: 'Export',
      },
    },
  },

  inbox: {
    pageTitle: 'Inbox',
    breadcrumbInbox: 'Inbox',
    breadcrumbArchive: 'Archive',
    breadcrumbTeam: 'Team: {team}',
    sidebar: {
      inbox: 'Inbox',
      archive: 'Archive',
      teamInbox: 'Team Inbox',
      loadingTeams: 'Loading teams…',
      noTeams: 'No teams',
    },
    list: {
      emptyHeadline: 'Empty',
      emptyBody: 'No items in this view.',
      noTitle: '(no title)',
      replies: '{count} reply | {count} replies',
      unread: 'unread',
    },
    chat: {
      show: 'Show chat',
      hide: 'Hide chat',
      sessions: 'Sessions',
    },
    effect: {
      title: 'This decision will be executed',
      detail: 'Note: {detail}',
      hint: 'On approval the server performs this change. '
        + 'The reason below is stated by the requesting agent and is not verified.',
    },
    detail: {
      backToList: 'Back to list',
      noTitle: '(no title)',
      fromLabel: 'From: {user}',
      toLabel: 'To: {user}',
      statusLabel: 'Status: {status}',
      criticalityLabel: 'Criticality: {criticality}',
      noBody: '(no body)',
      payload: 'Payload',
      answer: 'Answer',
      answerOutcome: 'Outcome: {outcome}',
      answerValue: 'Value:',
      answerReason: 'Reason: {reason}',
      answerBy: 'by {user}',
    },
    actions: {
      yes: 'Yes',
      no: 'No',
      send: 'Send',
      noOptionsHint: '(no options in payload — use the text reply below)',
      reasonPlaceholder: "Reason (optional, used by 'insufficient' / 'undecidable')",
      insufficientInfo: 'Insufficient info',
      undecidable: 'Undecidable',
      toDocument: 'To Document',
      delegate: 'Delegate',
      dismiss: 'Dismiss',
      archive: 'Archive',
      unarchive: 'Unarchive',
    },
    bulkArchive: {
      button: 'Archive by type…',
      title: 'Bulk-archive items by type',
      body:
        'All active items in the current view whose type is ticked below get archived in one go. The output-only types are preselected — decisions / approvals / orderings stay untouched until you tick them.',
      typesLegend: 'Types',
      countLabel: '{n} items will be archived',
      countNone: 'No matching items',
      confirm: 'Archive ({n})',
      cancel: 'Cancel',
      progress: 'Archiving {n}…',
    },
    delegate: {
      title: 'Delegate to teammate',
      body:
        'Hand this item to another team member. They will see it in their inbox and can answer / archive on your behalf.',
      recipient: 'Recipient',
      note: 'Note (optional)',
      cancel: 'Cancel',
      confirm: 'Delegate',
    },
    compose: {
      button: 'New message…',
      title: 'New inbox message',
      body:
        'Write a message into somebody\u2019s inbox — a colleague\u2019s, a team\u2019s, or your own. '
          + 'It opens a thread: a reply happens in its discussion, never as a request.',
      recipient: 'To',
      searchPlaceholder: 'Search a person or team…',
      userLabel: 'User',
      teamLabel: 'Team',
      selfLabel: 'Me',
      noMatches: 'No matches.',
      truncated: 'Showing the first {n} matches — refine the search to see more.',
      change: 'Change',
      subject: 'Subject',
      message: 'Message',
      cancel: 'Cancel',
      send: 'Send',
      sent: 'Message sent to {user}.',
      sentTeamOne: 'Message sent to team {team} (1 member).',
      sentTeam: 'Message sent to team {team} ({n} members).',
      reason: {
        no_debackupable_members: 'Nobody in this team could be reached — a team you are the '
          + 'only member of has no other desk for the message to land on.',
      },
    },
  },

  profile: {
    pageTitle: 'Profile',
    loading: 'Loading profile…',
    identity: {
      title: 'Identity',
      displayName: 'Display name',
      displayNamePlaceholder: 'e.g. Wile E. Coyote',
      email: 'Email',
      saved: 'Profile saved.',
      serverVersion: 'Server version',
      emailChange: {
        action: 'Change address',
        title: 'Change e-mail address',
        addressHelp: 'You sign in with a code sent to this address. We send a confirmation code to the new one first.',
        codeHelp: 'Enter the code we sent to {email}. The address changes once it is confirmed.',
        newAddress: 'New e-mail address',
        code: 'Code from the e-mail',
        sendCode: 'Send code',
        confirm: 'Confirm',
        startFailed: 'The code could not be sent. Check the address and try again.',
        invalidCode: 'The code is wrong or has expired.',
        reference: 'Reference: {id}. Use the code from the e-mail with this same reference.',
        done: 'E-mail address changed.',
      },
    },
    security: {
      title: 'Security',
      description: 'Change your account password.',
      currentPassword: 'Current password',
      newPassword: 'New password',
      newPasswordHelp: 'At least {min} characters.',
      repeatPassword: 'Repeat new password',
      submit: 'Change password',
      required: 'Enter your current and a new password.',
      mismatch: 'The new passwords do not match.',
      tooShort: 'Password must be at least {min} characters long.',
      changed: 'Password changed.',
      failed: 'Could not change password.',
      ssoAccount: 'You sign in with {provider} ({email}). This account has no password of its own.',
    },
    preferences: {
      title: 'Preferences',
      description:
        'Saved on your user-scope. Other clients (foot, mobile) ignore keys with the webui. prefix.',
      language: 'Language',
      languageBrowserDefault: 'Browser default',
      languageSaved: 'Language updated.',
      chatLanguage: 'Assistant language (chat)',
      chatLanguageNotSet: 'Not set (use tenant default)',
      chatLanguageDescription:
        'Which language the assistant replies and listens in. Projects can override this.',
      chatLanguageSaved: 'Assistant language updated.',
      timezone: 'Timezone',
      timezoneDescription:
        'Your local timezone. The assistant shows dates and times in it, and schedules you create fire at your local wall-clock time.',
      timezoneSaved: 'Timezone updated.',
      theme: 'Theme',
      themeAuto: 'System (auto)',
      themeLight: 'Light',
      themeDark: 'Dark',
      themeSaved: 'Theme updated.',
      uiLevel: 'Surface',
      uiLevelDescription:
        'Which tiles appear on the home page. Admin tiles follow your role, and server permissions apply independently.',
      uiLevelStandard: 'Standard (chat, documents, inbox)',
      uiLevelExpert: 'Expert (adds settings and runs)',
      uiLevelSaved: 'Surface updated.',
      openDocsNewTab: 'Open documents in a new browser tab',
      openDocsNewTabDescription:
        'When enabled, clicking a document link in the chat opens a new browser tab instead of replacing the current page. Cortex keeps its own in-app tab behaviour either way.',
      openDocsNewTabSaved: 'Preference updated.',
    },
    speech: {
      title: 'Speech & Audio',
      description:
        'Defaults for read-aloud and speech recognition. Voice depends on the languages your browser provides; the chat composer offers quick volume + rate sliders for the per-session adjust.',
      voice: 'Voice',
      voiceAuto: 'Auto',
      voiceDefaultSuffix: ' — default',
      voiceUnsupported: 'This browser has no speech-synthesis voices to choose from.',
      voiceSaved: 'Voice updated.',
      rate: 'Speed',
      rateSaved: 'Speed updated.',
      volume: 'Volume',
      volumeSaved: 'Volume updated.',
      talkCommandsTitle: 'Talk-mode voice commands',
      talkCommandsDescription:
        'In talk mode speech accumulates in the input; a voice command such as "Computer send" submits or steers. A command is "<name> <word>". Separate multiple words per action with commas.',
      talkTriggerNames: 'Trigger names',
      talkTriggerNamesHelp:
        'Wake words that may precede a command (comma-separated). "Computer" is transcribed reliably by speech recognition.',
      talkRequireName: 'Require trigger name',
      talkRequireNameHelp:
        'When on, a command only fires with a leading name ("Computer pause") — guards against accidental triggers.',
      talkAutoPause: 'Pause after sending',
      talkAutoPauseHelp:
        'When on, talk mode only listens after "send": speech is no longer dictated, but the reply is still read aloud. "Resume" picks dictation back up.',
      talkAction: {
        send: 'Send',
        clear: 'Correction (clear)',
        pause: 'Pause',
        resume: 'Resume',
        end: 'End',
      },
      talkCommandsSave: 'Save commands',
      talkCommandsResetBtn: 'Reset to defaults',
      talkCommandsSaved: 'Voice commands saved.',
      talkCommandsReset: 'Reset to defaults.',
      talkTriggerNamesPlaceholder: 'Computer',
    },
    teams: {
      title: 'Teams',
      empty: "You're not a member of any team in this tenant.",
      memberCountOne: '{count} member',
      memberCountOther: '{count} members',
      disabled: 'disabled',
      disabledTooltip: 'Team disabled by an administrator',
    },
  },
  starred: {
    resetApp: 'Reset the app — restart its program, discard runtime state',
    menuToggle: 'Starred',
    menuOnStartPage: 'Show on the start page',
    star: 'Star',
    unstar: 'Remove star',
    sectionTitle: 'Starred',
    broken: 'Target unreachable',
    reconcile: 'Check starred',
    reconcileOk: 'Everything up to date ({count} checked).',
    reconcileChanged: '{count} checked, {broken} unreachable.',
    remove: 'Remove star',
  },
  share: {
    title: 'Share “{name}”',
    loading: 'Loading ways to share…',
    noHandlers: 'No way to share configured.',
    viaLabel: 'Via {handler}',
    submit: 'Share',
    cancel: 'Cancel',
    back: 'Back',
    close: 'Close',
    errorGeneric: 'Sharing failed.',
    menuLabel: 'Share…',
    untitledSubject: 'this',
    subject: {
      titleLabel: 'Title',
    },
    inbox: {
      openInCortex: 'Open in Cortex',
      linkLabel: 'Shared link',
      documentLabel: 'Shared document',
    },
  },
  kindViews: {
    chart: {
      parseError: 'Chart could not be parsed: {message}',
      overrideHint: 'JSON merged on top of the generated ECharts option. Use sparingly.',
      dataHintPre: 'Edit data points in the',
      dataHintPost: 'tab.',
      title: 'Title',
      chart: 'Chart',
      subtitle: 'Subtitle',
      legend: 'Legend',
      stacked: 'Stacked',
      smooth: 'Smooth',
      xAxis: 'X-Axis',
      yAxis: 'Y-Axis',
      type: 'Type',
      series: 'Series',
      echartsOverride: 'ECharts override',
      raw: 'Raw',
      switchTypeTitle: 'Change chart type?',
      switchTypeMessage: 'A {to} chart needs a different data-point shape than {from}. The existing series data is dropped on save.',
      switchTypeConfirm: 'Change type',
    },
    diagram: {
      downloadSvg: '↓ SVG',
    },
    docx: {
      refreshTitle: 'Refresh the preview — shows changes after an Office edit was saved.',
      warnings: '{count} conversion note(s) — the layout may differ from Word.',
      loading: 'Loading DOCX…',
      failed: 'Could not read the DOCX:',
      refresh: '🔄 Refresh',
    },
    formula: {
      empty: 'Empty formula.',
    },
    questions: {
      error: 'The question set is invalid:',
      progress: 'Question {n} of {total}',
      overview: 'Overview — check and send',
      blocker: 'blocker',
      proposal: 'Assumption:',
      confirm: 'Confirm',
      freeText: 'Your answer (optional)',
      next: 'Next',
      back: 'Back',
      send: 'Send answers',
      settled: 'good as it is',
      later: 'later',
      unknown: "don't know",
      confirmed: 'confirmed',
      open: '—',
      answered: 'Answered.',
    },
    qrcode: {
      empty: 'Empty QR code — write the text or URL to encode into the document body.',
      error: 'The QR code could not be rendered:',
      canvasLabel: 'QR code',
      download: 'Download PNG',
    },
    office: {
      sdkFailed: 'Could not load the SDK from {url}: ',
      loading: 'Loading the Office editor…',
      notConfiguredHint: 'An administrator can wire up a self-hosted document-server instance under {path}.',
      notConfiguredPath: 'Settings → Integrations → Office editor (ONLYOFFICE / Collabora)',
      notConfigured: 'The Office editor is not configured for this project.',
      loadFailed: 'The editor could not be loaded:',
    },
    pdf: {
      label: 'PDF',
      close: 'Close',
    },
    sheet: {
      edit: 'Edit',
      empty: 'Empty sheet',
      label: 'Sheet',
    },
    xlsx: {
      loading: 'Loading XLSX…',
      failed: 'Could not read the XLSX:',
      refreshTitle: 'Refresh the preview — shows changes after an Office edit was saved.',
      refresh: '🔄 Refresh',
    },
    youtube: {
      videoLabel: 'YouTube video',
      noId: 'No usable YouTube video id could be read from the body.',
    },
  },
  shell: {
    expandSidebar: 'Expand sidebar',
    expandRightPanel: 'Expand right panel',
    sessions: 'Sessions',
    loading: 'Loading…',
  },
  linkCard: {
    openInBrowser: 'Open in browser',
    previewUnavailable: 'Preview unavailable',
    loadingPreview: 'Loading preview…',
  },
  formView: {
    designHint: 'Design mode — form fields (stored in the block). Data:',
    applyFields: 'Apply fields',
    addRecord: '+ Add record',
    cancel: 'Cancel',
    saving: 'Saving…',
    save: 'Save',
    loading: 'Loading form…',
    namePlaceholder: 'name',
    label: 'Label',
    required: 'req',
    allowCustom: 'custom values',
    moveUp: 'Move up',
    moveDown: 'Move down',
    remove: 'Remove',
    choicesHint: 'One choice per line — value or value|Label',
    addField: '+ Add field',
    applied: 'Applied ✓',
    removeRecord: 'Remove record',
    saved: 'Saved ✓',
    unsaved: 'Unsaved changes',
    singleRecord: 'Single record (one form instead of a card list)',
    scriptSession: 'Session for the script (only for LLM / session-bound tools)',
  },
  chatPanel: {
    connecting: 'Connecting…',
    elsewhere: 'This session is open in another window or on another device — it is not connected here.',
    session: 'Session',
    sessionId: 'Session ID',
    reconnect: 'Reconnect',
    takeOver: 'Take over here',
    retry: 'Retry',
  },
  explorer: {
    colName: 'Name',
    colKind: 'Kind',
    colTags: 'Tags',
    colSize: 'Size',
    colCreated: 'Created',
    colUpdated: 'Modified',
    colBy: 'By',
    folder: 'folder',
  },
  panic: {
    pressAnyKey: 'press any key',
  },
  templateResult: {
    applied: 'Template {name} applied.',
  },
  inlineKind: {
    noProject: 'No current project — bind a chat session first.',
    saved: 'Saved: {path} — link copied',
    saveFailed: 'Save failed: {message}',
    pathPrompt: 'Path for the new document:',
  },
  compose: {
    runCompose: '▶ Run compose',
    stop: '■ Stop',
    clearOutput: 'Clear Output',
    workspaceLine: 'Workspace: {workspace} · {outcome}',
    success: 'success',
    failed: 'failed',
    progress: 'Running… task {index}',
    progressWithType: 'Running… task {index} ({type})',
    runGone: 'Run no longer available (pod restart?) — please run it again.',
  },
  templateInput: {
    settingHelp: 'Stored encrypted in the settings.',
  },
  workspace: {
    loadingFile: 'Loading file…',
    pickProjectHint: 'Pick a project in the sidebar filter to see the workspace.',
    empty: {
      emptyTreeHeadline: 'Empty workspace',
      emptyTreeBody: 'This project has no files in its workspace yet.',
    },
    preview: {
      pickFileHeadline: 'No file selected',
      pickFileBody: 'Click a file in the tree on the left to view it here.',
      binaryHeadline: 'Binary file',
      binaryBody: 'This file type cannot be previewed — download it instead.',
      download: 'Download',
    },
    footer: {
      podHint: 'Live view from the project home pod.',
      refresh: 'Reload',
    },
  },
  blockEditor: {
    slash: {
      paragraph: { title: 'Text', hint: 'Plain paragraph' },
      'heading-1': { title: 'Heading 1', hint: 'Large section heading' },
      'heading-2': { title: 'Heading 2', hint: 'Medium heading' },
      'heading-3': { title: 'Heading 3', hint: 'Small heading' },
      bullet: { title: 'Bullet list', hint: '- item' },
      numbered: { title: 'Numbered list', hint: '1. item' },
      todo: { title: 'To-do', hint: '- [ ] task' },
      quote: { title: 'Quote', hint: 'Set-off citation' },
      code: { title: 'Code block', hint: 'Fenced code' },
      divider: { title: 'Divider', hint: '---' },
      toggle: { title: 'Toggle', hint: 'Collapsible section' },
      'link-card': { title: 'Link card', hint: 'Rich URL preview' },
      dataview: { title: 'Dataview', hint: 'Embed aggregation (stub)' },
      image: { title: 'Image', hint: 'Pick from assets or upload' },
      toc: { title: 'Table of contents', hint: 'Auto-generated from page headings' },
      embed: { title: 'Embed document', hint: 'Inline another Vance document — kind-aware card' },
      form: { title: 'Form', hint: 'Editable data-entry form (bound to an edit-config)' },
      input: { title: 'Input', hint: 'Editable text bound to a file (single or multi-line)' },
      button: { title: 'Button', hint: 'Clickable button that runs a script' },
      field: { title: 'Form field', hint: 'Question with an inline answer (choice, multi, text…)' },
      compose: { title: 'Compose', hint: 'Run a Damogran compose task inline' },
      columns2: { title: '2 columns', hint: 'Side-by-side layout' },
      columns3: { title: '3 columns', hint: 'Three-pane layout' },
      callout: { title: 'Callout', hint: 'Info / Warn / Note' },
      composeJs: { title: 'Compose JS', hint: 'Compose block with one JS task' },
      composeBash: { title: 'Compose Bash', hint: 'Compose block with one shell task' },
      composePython: { title: 'Compose Python', hint: 'Compose block with one Python task' },
      composeR: { title: 'Compose R', hint: 'Compose block with one R task (Rserve, WORK-only)' },
      composeAgent: { title: 'Compose Agent', hint: 'Compose block with one agent task' },
      menuTitle: 'Insert block',
      noMatch: 'No matching block',
    },
    callout: {
      defaultTitle: 'Note',
      titlePlaceholder: 'Title (optional)',
      bodyPlaceholder: 'Body…',
    },
    compose: {
      agentPlaceholder: 'Summarise the files in the workspace.',
      settingsYaml: 'Settings (YAML)',
      run: 'Run',
      runCompose: 'Run compose',
      stop: 'Stop',
      running: 'Running…',
      moreActions: 'More actions',
      runAllUntil: 'Run All Until',
      clearOutput: 'Clear Output',
      clearAllOutput: 'Clear All Output',
      stopping: 'stopping…',
      runGone: 'Run no longer available (pod restart?) — please run it again.',
      runFailed: 'Compose run failed',
    },
    blocks: {
      dataview: 'Dataview',
      dataviewHint: 'Dataview rendering not yet implemented.',
      toc: 'Table of contents',
      tocEmpty: 'No headings on this page yet.',
      compose: '⚙ Compose',
      embed: '🔗 Embed',
      form: '📝 Form',
      input: '✏ Input',
      button: 'Button',
      field: 'Form field',
      runnableHint: 'Runnable in the editor.',
      editableHint: 'Editable in the editor.',
      copyLink: 'Copy link',
    },
    handle: {
      insertAbove: '↑ Insert above',
      insertBelow: '↓ Insert below',
      copy: '⧉ Copy',
      paste: '📋 Paste (below)',
      delete: '🗑 Delete',
    },
    bubble: {
      bold: 'Bold (Ctrl+B)',
      italic: 'Italic (Ctrl+I)',
      strike: 'Strike',
      inlineCode: 'Inline code',
      link: 'Link (Ctrl+K)',
      width: 'Width: {size}',
    },
    trash: {
      over: 'Release to delete',
      idle: 'Drop here to delete',
    },
    input: {
      saveScript: 'saveScript',
      saveScriptPlaceholder: 'e.g. update.js (relative to the folder, optional)',
      sessionForScript: 'Session for the script (only for LLM / session-bound tools)',
      saved: 'Saved ✓',
      cancel: 'Cancel',
    },
    button: {
      typeScript: 'script',
      typeFormResolve: 'Resolve',
      typeFormReset: 'Reset',
      runDefault: 'Run',
      score: '{correct} of {total} correct',
      titlePlaceholder: 'Button title…',
      scriptPlaceholder: 'script (e.g. myscript.js or vance:/apps/x/run.js)',
    },
    field: {
      typeText: 'Text (single line)',
      typeTextarea: 'Text (multi-line)',
      typeChoice: 'Single choice',
      typeMulti: 'Multiple choice',
      typeDropdown: 'Dropdown',
      idPlaceholder: 'Field id (e.g. q1)',
      questionPlaceholder: 'Question…',
      optionsPlaceholder: 'One option per line…',
      solutionPlaceholder: 'Solution (index, comma list for multi, else text)',
      answerPlaceholder: 'Answer…',
      selectPlaceholder: '— pick —',
      judgePlaceholder: 'Grading criteria for the LLM judge (free text; empty = not graded)…',
    },
    embed: {
      refresh: "Refresh — embedded documents don't auto-update",
      open: 'Open document (or ⌘/Ctrl+click)',
    },
    link: {
      titlePlaceholder: 'Link title…',
      descriptionPlaceholder: 'Description (optional)…',
      hrefPlaceholder: 'https://…',
    },
    toggleBlock: {
      summaryPlaceholder: 'Summary…',
      bodyPlaceholder: 'Body (Markdown)…',
      defaultSummary: 'Details',
    },
    form: {
      title: 'Form',
    },
    image: {
      loading: 'Loading image…',
      noSource: 'No image source',
    },
  },
  form: {
    removeItem: 'Remove',
    filterPlaceholder: 'Filter…',
    noMatches: 'Nothing matches the filter.',
    selectedCount: '{count} selected',
    clearSelection: 'Clear',
    customValueHint: 'Not in the list — custom or outdated value.',
  },
  settings: {
    pageTitle: 'Settings',
    scope: {
      tenant: 'Tenant',
      user: 'My settings',
    },
    sidebar: {
      user: 'My settings',
      tenant: 'Tenant',
      projects: 'Projects',
      ungrouped: 'Ungrouped',
      emptyHeadline: 'No projects',
      emptyBody: 'Projects you can access appear here.',
    },
    tab: {
      areas: 'Areas',
      project: 'Project',
      tenant: 'Tenant',
      forms: 'Settings',
      raw: 'Advanced',
      actions: 'Actions',
    },
    actions: {
      run: 'Run',
      empty: 'No actions available in this scope.',
    },
    backToListing: 'Back',
    emptyHeadline: 'Nothing to configure here',
    emptyBody:
      'No Setting Forms are available for this scope.',
    areas: {
      research: {
        title: 'Research',
      },
      mounts: {
        title: 'Mounts',
      },
      models: {
        title: 'AI models',
        createHint:
          'Just the provider name for a new provider instance; "provider/model" for a new model document.',
      },
      recipes: {
        title: 'Recipes',
        createHint: 'A kebab-case name — it becomes the filename and with it the recipe name.',
      },
      chatThemes: {
        title: 'Chat themes',
        createHint: 'A kebab-case name (lowercase letters, digits, dash only) — recipes pick it via the webTheme field.',
      },
      reportThemes: {
        title: 'Report themes',
        createHint: 'A kebab-case name (lowercase letters, digits, dash only) — documents pick it via the theme frontmatter key.',
      },
      prompts: {
        title: 'Prompts',
        createHint:
          'The name of the engine prompt to override (e.g. arthur-prompt) — same file, own layer: the document shadows the bundled version.',
      },
      schedulers: {
        title: 'Schedulers',
        createHint:
          'Kebab-case name — it becomes the file name and with it the scheduler name. Firing and the event log stay in Insights.',
      },
      workflows: {
        title: 'Workflows',
        createHint: 'Kebab-case name — it becomes the file name and with it the workflow name.',
      },
      serverTools: {
        title: 'Server tools',
        createHint:
          'Snake_case name (lowercase letters, digits, _) — it becomes the file name and the tool name. A new tool starts as a disabled MCP server: fill in the server, then enable it.',
        errors: {
          userScope: 'Server tools exist for the tenant and for projects, not per user.',
          invalidName: 'A tool name is snake_case: lowercase letters, digits and _.',
        },
      },
      hooks: {
        title: 'Hooks',
        createHint:
          '"event/hook-name" — e.g. process.completed/notify-owner. The event is a path segment, the name lowercase with _ and -.',
      },
      guards: {
        title: 'Guards',
        createHint:
          'Kebab-case name — it becomes the file name; the recipe cites the path in its guard: block. No top-level return in the script (GraalJS rejects it).',
      },
      wizards: {
        title: 'Wizards',
        createHint:
          'Kebab-case name — it becomes the file name; the same name in an inner cascade tier shadows this wizard.',
      },
      backToAreas: 'Back to areas',
      backToEntries: 'Back to the list',
      addEntry: 'Add',
      deleteEntry: 'Delete',
      nameLabel: 'Name',
      namePlaceholder: 'e.g. serper-main',
      confirmDeleteEntry: 'Delete "{name}"? This cannot be undone.',
      inherited: {
        tenant: 'Tenant',
        bundled: 'Built-in',
      },
      override: 'Override here',
      confirmOverride:
        '"{name}" comes from the {origin} layer. Create your own copy in this scope? It shadows the inherited entry here; deleting the copy brings the inherited one back.',
      emptyHeadline: 'No entries in this area',
      emptyBody: 'Nothing of this kind is configured in the selected scope yet.',
      noneHeadline: 'No areas',
      noneBody: 'No configuration areas are registered in this build.',
      save: 'Save',
      entrySaved: 'Saved.',
      apply: 'Apply',
      openInCortex: 'Open this document in Cortex',
      parseFailedRaw:
        'This document could not be parsed as its kind expects — editing the raw text instead.',
    },
    raw: {
      hint:
        'Free-form key/value editing for keys no form covers yet. Values resolve through the settings cascade (project → tenant).',
      emptyHeadline: 'No explicit settings on this layer',
      emptyBody:
        'Nothing is set directly here — effective values may come from an outer layer of the cascade.',
      valueLabel: 'Value',
      newPasswordLabel: 'New password',
      passwordLabel: 'Password',
      passwordEmptyToKeep: 'Leave empty to keep the stored secret',
      descriptionLabel: 'Description',
      descriptionOptional: 'Description (optional)',
      keyLabel: 'Key (dot notation)',
      keyPlaceholder: 'e.g. ai.default.model',
      typeLabel: 'Type',
      addTitle: 'Add setting',
      add: 'Add',
      edit: 'Edit',
      deleteLabel: 'Delete',
      confirmDelete: 'Delete setting "{key}" from this layer? Outer layers apply again.',
      cancel: 'Cancel',
      save: 'Save',
      empty: '(empty — inherits)',
      explicitEmpty: '(empty — does not inherit)',
      maskedSet: '[set]',
      types: {
        string: 'String',
        int: 'Int',
        long: 'Long',
        double: 'Double',
        boolean: 'Boolean',
        password: 'Password',
        hidden: 'Hidden',
      },
    },
  },
};
